<template>
	<div class="home">
		<div class="main mplus bg" :class="channel">
			<div class="bar-close"><input type="checkbox" id="nav" /><label for="nav" id="menu" :class="ch"></label></div>
			<div class="bar-bd">
			</div>
			<div class="bar-pc" style="opacity:0;">
				<div class="title josefin box">
					<div class="title-text">
						Unit Stories M<img :src="'img/batsu_mre.png'" alt="x" class="batsu">R<img :src="'img/batsu_mre.png'" alt="x"
							class="batsu">E
					</div>
					<div class="title-link josefin"><router-link class="title-link-text" tag="div" :to="`/schedule`"
							key="0">schedule &
							ticket</router-link><span class="divider-vertical">|</span>
						<router-link class="title-link-text" tag="div" :to="`/event`" key="1">event & present</router-link><span
							class="divider-vertical">|</span>
						<router-link class="title-link-text" tag="div" :to="`/goods`" key="2">goods</router-link>
						<span class="divider-vertical">|</span>
						<router-link class="title-link-text" tag="div" :to="`/guide`" key="3">guide</router-link>
					</div>
				</div>
			</div>
			<div class="bar-outer">
				<div class="story-title josefin title-text" :class="channel">
					<div class="mplus jp">ジュエルステージ「オンエア！」</div><br />
					Unit Stories M<img :src="batsu" alt="x" class="batsu">R<img :src="batsu" alt="x" class="batsu">E
				</div>
				<div class="bar josefin">
					<router-link class="mre-link-bar maisy" tag="div" to="/maisy" key="1"
						:class="{ selected: ch === 'maisy' }"><span class="uss">Unit Story side </span><br />MAISY</router-link>
					<router-link class="mre-link-bar refly" tag="div" to="/refly" key="2"><span class="uss">Unit Story side
						</span><br />Re:Fly</router-link>
					<router-link class="mre-link-bar emekare" tag="div" to="/emekare" key="3"><span class="uss">Unit Story side
						</span><br />
						<div class="eme">エメ☆カレ</div>
					</router-link>
					<div class="divider wide" :class="channel"></div>
					<router-link class="mre-link-text schedule josefin" tag="div" to="/schedule" key="4">schedule & ticket
					</router-link>
					<router-link class="mre-link-text event josefin" tag="div" to="/event" key="5">event & present
					</router-link>
					<router-link class="mre-link-text event josefin" tag="div" to="/goods" key="6">goods
					</router-link>
					<router-link class="mre-link-text event josefin" tag="div" to="/guide" key="7">guide
					</router-link>
				</div>
			</div>
			<div class="main-visual-box-outer hide-bar" :class="channel">
				<div class="main-visual-box box">
					<TransitionGroup mode="out-in" name="fade" class="main-visual-box-inner" :duration="{ enter: 500, leave: 500 }">
						<img v-for="(visual, index) in keyvisuals" :key="`visual-${index}`" v-show="visual.ch === channel"
							:src="`img/${visual.ch}/${visual.img}`" title="ジュエルステージ「オンエア！ Unit Stories M×R×E"
							class="main-visual-image" />
					</TransitionGroup>
				</div>
				<div class="mre-links-box box">
					<router-link class="mre-link maisy" tag="div" to="/maisy" v-show="channel !== 'maisy'" key="1"><img
							src="../../public/img/maisy/stlogo_maisy.png" alt="" class="mre-link-image"></router-link>
					<router-link class="mre-link refly" tag="div" to="/refly" v-show="channel !== 'refly'" key="2"><img
							src="../../public/img/refly/stlogo_refly.png" alt="" class="mre-link-image"></router-link>
					<router-link class="mre-link emekare" tag="div" to="/emekare" v-show="channel !== 'emekare'" key="3"><img
							src="../../public/img/emekare/stlogo_emekare.png" alt="" class="mre-link-image">
					</router-link>

				</div>
			</div>
			<div class="main-data-box" :class="channelBg">
				<div class="main-data-head-outer">
					<div class="main-data-head" :class="channel"><span class="main-data-head-text">「MAISY」「Re:Fly」「エメ☆カレ」<br
								class="brsp" />各ユニット単独・回替わり公演決定！</span></div>
				</div>
				<div class="main-data-dates-text josefin">
					<time datetime="2022-11-11" v-html="this.datetext"></time>
					<span class="to mplus">▶︎</span><time datetime="2022-11-27" v-html="this.todatetext"></time>
				</div>
				<div class="main-data-place-text mplus">品川プリンスホテル クラブeX</div>

				<div class="main-data-credits-text">
					原作：『オンエア！』／coly<br />
					脚本・作詞：浅井さやか<span class="kakko2 smaller">
						（One on One）</span>&#x3000;<br class="brsp">
					演出：伊藤マサミ<span class="kakko2 smaller">（進戯団 夢命クラシックス）</span>&#x3000;<br class="brsp">音楽：<span class="credit-music"
						v-html="music"></span></div>
				<div class="flyer-link" id="flyer" :class="channel"><a href="pdf/OA_MRE_flyer.pdf" target="_blank"><span
							class="flyer-link-text">電子チラシ</span></a></div>
			</div>

			<div class="bg1-box box">
				<div class="news">
					<div class="notice-link-box">
						<div class="inner box">
							<router-link :to="`/guide`" tag="div" class="notice-link-text">
								<div class="notice-text noto"><span class="en josefin">guide</span>［ 公演に関するお知らせ ］</div>
								<div class="notice-text-add noto">ご来場の前に必ずお読みください</div>
							</router-link>
						</div>
					</div>
					<div class="news-outer">
						<div class="news-inner box" :class="channel">
							<div class="info-title josefin title-text" :class="channel">
								NEWS
							</div>
						</div>
						<div class="news-info-box align-left box" id="app">
							<template v-for="(item, index) in this.news">
								<transition name="toggle-slide" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave"
									@leave="leave" @after-enter="afterEnter" @css="false" :duration="400"
									:key="`news-transition-${item.id}`">
									<div class="news-item-outer" v-show="index < show">
										<div class="news-item" :key="`news-item-${item.id}`" :class="{ 'closed': !isOpen(item.id) }">
											<div class="news-head foldable" @click="newsToggle(item.id, item.atext)"
												:class="[`news-id-${item.id}`, channel]">
												<div class="news-date josefin" :class="channel"><time :datetime="item.date">{{
													dateFormatted(item.date)
												}}</time><span v-if="isNew(item.date)" class="new-tick uppercase" :class="channel">
														new</span></div>
												<div class="news-title mplus" :class="channel">{{ item.title }}
												</div>
											</div>
											<transition name="toggle-slide" @before-enter="beforeEnter" @enter="enter"
												@before-leave="beforeLeave" @leave="leave" @css="false" :duration="400">
												<div class="news-text-box" v-show="isOpen(item.id)">
													<div class="news-text mplus align-left" v-html="item.atext" :class="channel"></div>
												</div>
											</transition>
										</div>
									</div>
								</transition>
							</template>
							<div class="more-box">
								<button class="news-more josefin" @click="more()" v-if="areMore" v-html="moreWord"
									:class="channel"></button>
							</div>
						</div>
					</div>
				</div>
				<div class="story-box box" id="story">
					<div class="intro-title josefin title-text" :class="channel">
						<div class="mplus jp">ジュエルステージ「オンエア！」</div><br />
						Unit Stories M<img :src="batsu" alt="x" class="batsu">R<img :src="batsu" alt="x" class="batsu">E
					</div>
					<div class="story-text-box"><span
							class="intro-text">株式会社colyから配信されたスマートフォン向けアプリゲーム『オンエア！』の舞台化作品・ジュエルステージ「オンエア！」。本シリーズは、<time
								datetime="2022-06-03">2022年6月</time>に30の「宝石の原石」たちが輝きを放った最初のステージを皮切りに、<time
								datetime="2022-11-11">同年11月</time>には“気高き天才スター集団「Prid’s」”に焦点を絞ったユニット公演を上演した。<br /><br />そして、Prid’sから始まったユニット公演は、“個性豊かなバラエティ集団「MAISY」”、“大人なプロフェッショナル集団「Re:Fly」”、“夢の世界に誘うアイドル集団「エメ☆カレ」”の3ユニットにバトンが渡される。<br />なんと今回は<time
								datetime="2023-07-15">2023年7</time>～<time
								datetime="2022-08-06">8月</time>に、3ユニットの各単独公演を回替わりでお届け！<br />さらにMAISY公演の音楽をYu(vague)、Re:Fly公演を伊 真吾(OVERCOME
							MUSIC)、エメ☆カレ公演を大石憲一郎が手掛け、ユニットの個性が光る音楽と共に各ユニットの誕生秘話を描く！</span>
					</div>
					<div class="divider wide thin-white"></div>
					<div class="story-title josefin title-text" :class="channel">
						STORY <span class="smaller">Side <span v-html="channelName"></span></span>
					</div>
					<div class="story-text-box intro"><span class="story-text" v-html="story"></span>
					</div>
					<div class="divider wide" :class="channel"></div>
				</div>
				<div class="cast-outer" :class="channel">
					<div class="cast-bg box">
						<div class="cast">
							<div class="cast-title uppercase josefin">cast</div>
							<div id="app-cast">
								<div class="unit-name-text josefin" v-html="channelName" :class="channel"></div>
								<div class="cast-list-box"><template v-for="(member, index) in this.castList">
										<div v-if="member.skip === true" class="divider wide wider thin-white" :key="`cast-${index}`"></div>
										<div v-else class="cast-list-item" :key="`cast-${index}`">
											<div class="cast-image-box"><img :src="castImage(channel, member)" :alt="member.cname"
													class="cast-image" :class="index < 5 ? channel : 'others'"></div>
											<div class="character" v-html="member.cname"></div>
											<div class="actor" v-html="member.aname"></div>
										</div>
									</template>
								</div>
								<div class="cast-guest">
									ゲストユニット：<span class="cast-guest-text" :class="guestUnitColor"><span class="unit-name"
											v-html="guestUnit"></span>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="divider wide" :class="channel"></div>
				<div class="staff-box box">

					<div class="staff-title josefin title-text" :class="channel">
						STAFF
					</div>
					<div class="staff-text">原作：『オンエア！』／coly<br />
						<br />
						脚本・作詞：浅井さやか（One on One）<br />
						演出：伊藤マサミ（進戯団 夢命クラシックス）<br />
						音楽：<span class="credit-music" v-html="music"></span><br />
						<br />
						演出補佐：友花&#x3000;振付：はこログ&#x3000;美術：小林奈月<br />
						照明：大波多秀起&#x3000;音響：相川幸恵&#x3000;映像：O-beron inc.<br />
						衣裳：川島加菜果（とわづくり）&#x3000;ヘアメイク：柴崎尚子&#x3000;特殊造形：林屋陽二<br />
						歌唱指導：都乃&#x3000;演出助手：長谷川 景&#x3000;<br class="brsp" />舞台監督：横川奈保子&#x3000;技術監督：寅川英司<br />
						<br />
						宣伝美術：syla&#x3000;宣伝写真：上村可織<br />
						<br />
						制作：ネルケプランニング<br />
						<br />
						協賛：ローソンチケット<br />
						<br />
						主催：ジュエルステージ「オンエア！」製作委員会<br />
					</div>
				</div>
				<div class="divider wide" :class="channel"></div>
				<div class="banner">
					<div class="head bolder josefin" :class="ch">Unit Stories M<img :src="batsu" alt="x" class="batsu">R<img
							:src="batsu" alt="x" class="batsu">E<br />
						<div class="uppercase">Information</div>
					</div>
					<router-link class="event-link-box" tag="div" :to="`/schedule`" key="11">
						<div class="text josefin">schedule & ticket</div>
						<div class="copy">スケジュール・チケット</div>
					</router-link>
					<router-link class="event-link-box" tag="div" :to="`/event`" key="12">
						<div class="text josefin">event & present</div>
						<div class="copy">イベント・特典</div>
					</router-link>
					<router-link class="event-link-box" tag="div" :to="`/goods`" key="13">
						<div class="text josefin">goods</div>
						<div class="copy">グッズ</div>
					</router-link>
				</div>
				<div class="divider wide wider thin-white"></div>
				<div class="streaming" id="streaming">
					<div class="streaming-box">
						<div class="inner box">
							<div class="streaming-border">
								<div class="streaming-title">
									<div class="streaming-head noto" :class="ch">
										<div class="text josefin">live streaming</div>
										<div class="copy">ライブ配信</div>
									</div>
									<!-- <div class="streaming-text-add noto">ご来場の前に必ずお読みください</div> -->
								</div>
								<div class="data-text" :class="`a-${ch}`">
									<span class="head bolder">配信プラットフォーム</span><br />
									<a href="https://eplus.jp/st-onair-stage/" target="_blank" rel="noopener noreferrer"
										class="streaming-url">Streaming+<br />
										<div class="streaming-link" :class="`a-${ch}`"><span class="text">購入ページはこちら</span></div>
									</a>
									<br />
									<span class="head bolder">対象公演</span><br />
									MAISY：<time datetime="2023-08-05T18:00">2023年8月5日<span class="kakko">（土）</span>18:00</time>公演<br />
									エメ☆カレ：<time datetime="2023-08-06T13:00">2023年8月6日<span class="kakko">（日）</span>13:00</time>公演<br />
									Re:Fly：<time datetime="2023-08-06T18:00">2023年8月6日<span class="kakko">（日）</span>18:00</time>公演<br />
									<br />
									<span class="head bolder">販売価格</span><br />
									各3,800円<span class="kakko">（税込）</span><br />
									<ul>
										<li>※1週間の見逃し視聴付き。</li>
										<li>※詳しくは<a href="https://eplus.jp/st-onair-stage/" target="_blank"
												rel="noopener noreferrer">購入ページ</a>をご確認ください。</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer :channel="channel" :channelBg="channelBg"></Footer>
	</div>
</template>

<script>
// @ is an alias to /src
import Footer from '@/components/Footer.vue'
import $ from 'jquery'

export default {
	name: 'Home',
	components: {
		Footer,
	},
	props: [
		"ch"
	],
	data: () => ({
		show: 3,
		less: 3,
		open: [],
		moreWord: "More..."
	}),
	watch: {
		$route(to) {
			// console.log([to])
			this.$store.commit('setChannel', to.name);
		}
	},
	mounted: function () {
		this.nav();
		this.$store.commit('setChannel', this.ch);
		this.$store.commit('getNews');
	},
	methods: {
		nav() {
			$("#nav").click(function () {
				if (document.body.clientWidth <= 768) {
					if ($("#nav").prop("checked")) {
						$(".bar-bd").fadeIn(10);
						$(".bar-outer").slideDown(200);
						$('body').addClass('modal-wait');
					} else {
						$(".bar-bd").fadeOut(200);
						$(".bar-outer").fadeOut(200);
						$('body').removeClass('modal-wait');
					}
				}
			});
			$('.bar').click(function () { // event
				if (document.body.clientWidth <= 768) {
					// if (!$(event.target).closest('#nav').length) {
					$(".bar-bd").fadeOut(200);
					$(".bar-outer").fadeOut(200);
					document.querySelector('#nav').checked = false;
					// }
				}
			});
			createObserver();
			function createObserver() {
				let callback = (entries) => {
					entries.forEach(entry => {
						// console.log(entry.intersectionRatio)
						if (entry.isIntersecting) {
							document.querySelector('.bar-pc').classList.add('hide');
							document.querySelector('.bar-pc').classList.remove('show');
						} else {
							if (document.querySelector('.bar-pc')) {
								document.querySelector('.bar-pc').classList.remove('hide');
								document.querySelector('.bar-pc').classList.add('show');
							}
						}
					});
				};
				let options = {
					root: null,
					rootMargin: '100px',
					threshold: 0.7
				}
				let observer = new IntersectionObserver(callback, options);
				let target = document.querySelectorAll('.hide-bar');
				target.forEach(item => {
					observer.observe(item);
				});
			}
		},
		dateFormatted(date) {
			if (!date) {
				return '';
			}
			let [y, m, d] = date.split('-');
			let formatted = `${y}/${m}/${d}`;
			return formatted;
		},
		// https://qiita.com/randy39/items/67d956f5b10ebce7a0a5
		newsToggle(index, foldable) {
			if (foldable) {
				this.$set(this.open, index, !this.open[index]);
			}
		},
		isNew(date) {
			let [y, m, d] = date.split('-');
			let dt = new Date(y, m - 1, d).getTime();
			let td = new Date().getTime();
			let days = (td - dt) / 86400 / 1000;
			return (days <= 7);
		},
		isOpen(index) {
			return this.open[index];
		},
		// transition hook
		beforeEnter(el) {
			el.style.height = '0'
		},
		enter(el) {
			el.style.height = el.scrollHeight + 'px'

		},
		beforeLeave(el) {
			el.style.height = `${el.scrollHeight}px`;
			el.style.height = `${el.scrollHeight}px`;
		},
		leave(el) {
			el.style.height = '0'
		}, afterEnter(el) {
			el.style.height = 'auto'
		},
		channelTo(channel) {
			this.$store.commit('channelTo', channel);
		},
		more() {
			if (this.show == this.less) {
				this.show = this.newsLength;
				this.moreWord = "less";
			} else {
				this.show = this.less;
				this.moreWord = "More...";
			}
			return this.show;
		},
		castImage(channel, member) {
			if (member.folder) {
				return `img/${member.folder}/${member.img}`
			} else {
				return `img/${channel}/${member.img}`
			}

		}
	},
	computed: {
		datetext() {
			let channel = this.$store.state.channel;
			let dates = this.$store.state.dates[channel];
			let [y, m, d, dy] = [dates.year, dates.month, dates.date, dates.day];
			return `${y} ${m}.${d} <span class="day">${dy}</span>`;
		},
		todatetext() {
			let channel = this.$store.state.channel;
			let dates = this.$store.state.dates[channel];
			let [m, d, dy] = [dates.tomonth, dates.todate, dates.today];
			return `${m}.${d} <span class="day">${dy}</span>`;
		},
		castList() {
			let channel = this.$store.state.channel;
			let list = this.$store.state.casts[channel];
			return list;
		},
		channel() {
			return this.$store.state.channel;
		},
		channelName() {
			let channel = this.$store.state.channel;
			return this.$store.state.channelNames[channel];
		},
		channelBg() {
			let channel = this.$store.state.channel;
			return `${channel}Bg`;
		},
		news() {
			let channel = this.$store.state.channel;
			let news = [];
			for (let article of this.$store.state.news) {
				if (article.ch == channel || article.ch == 'mre') {
					news.push(article);
				}
			}
			return news;
		},
		newsLength() {
			let channel = this.$store.state.channel;
			let len = 0;
			for (let article of this.$store.state.news) {
				if (article.ch == channel || article.ch == 'mre') {
					len++;
				}
			}
			// console.log(channel);
			// if (this.$store.state.news[channel]) {
			// 	return this.$store.state.news[channel].length;
			// }
			// else { return 0; }
			return len;
		},
		areMore() {
			return this.less < this.newsLength;
		},
		keyvisual() {
			let channel = this.$store.state.channel;
			let image = this.$store.state.keyvisuals[channel];
			return `${channel}/${image}`;
		},
		keyvisuals() {
			let channels = this.$store.state.channels;
			let visuals = [];
			for (let ch of channels) {
				let img = this.$store.state.keyvisuals[ch];
				// let title = this.$store.state.titles[ch];
				visuals.push({ 'ch': ch, 'img': img })
			}
			return visuals;
		},
		music() {
			let channel = this.$store.state.channel;
			let musician = this.$store.state.music[channel];
			return musician;
		},
		batsu() {
			let channel = this.$store.state.channel;
			return `img/${channel}/batsu_${channel}.png`;
		},
		story() {
			let channel = this.$store.state.channel;
			return this.$store.state.stories[channel];
		},
		guestUnit() {
			let channel = this.$store.state.channel;
			return this.$store.state.guest[channel];
		},
		guestUnitColor() {
			let channel = this.$store.state.channel;
			return `${this.$store.state.guestUnitColor[channel]}Bg`;
		}
	}
}
</script>
<style lang="scss">
.divider.wide {
	width: 100vw;
	background: url(../../public/img/maisy/kei_maisy.png) repeat-x;
	height: 23px;
	margin-left: calc(50% - 50vw);

	&.refly {
		background: url(../../public/img/refly/kei_refly.png) repeat-x;
		height: 23px;
	}

	&.emekare {
		background: url(../../public/img/emekare/kei_emekare.png) repeat-x;
		height: 23px;
	}

	&.thin {
		height: 7px;
	}

	&.thin-white {
		background: url(../../public/img/kei_white.png) repeat-x;
		height: 7px;

		&.wider {
			margin-left: calc(50% - 50vw);
			margin-right: calc(50% - 50vw);
			width: 100vw;
		}
	}
}

@keyframes fadeIn {
	0% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
}

.news-text {
	&.maisy a {
		color: $orange;

		&:hover {
			color: $liteorange;
		}
	}

	&.refly a {
		color: $blue;

		&:hover {
			color: $liteblue;
		}
	}

	&.emekare a {
		color: $green;

		&:hover {
			color: $litegreen;
		}
	}

	a {
		font-weight: 500;
	}
}
</style>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
	transition: all 0.5s ease;
}

.fade-leave-active {
	position: absolute;
	z-index: 2;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.fade-enter-active {
	position: absolute;
	z-index: 1;
}

.bar-pc {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	height: 3.5rem;
	color: transparent;
	display: flex;
	z-index: 3;
	border: 0;
	width: 100vw;
	margin: 0 auto;
	opacity: 0;
	transition: opacity 1s;
	background: url(../../public/img/mre_menu.png) no-repeat, linear-gradient(to right, $liteorange, $liteorange 50%, $litegreen 50%, $litegreen), ;
	background-size: 1024px auto, 100%;
	background-position: center top, center top;

	&.show {
		opacity: 0.8 !important;

		@media screen and (max-width: 768px) {
			opacity: 0 !important;
		}
	}

	&.hide {
		opacity: 0 !important;
	}

	@media screen and (max-width: 768px) {
		display: none;
	}

	&:hover {
		opacity: 1;
	}

	.title {
		display: flex;

		align-items: center;
		width: 100%;
	}

	.title-text {
		font-size: 1.9rem;
		text-align: left;
		justify-self: flex-start;
		padding: 1.25rem 2rem 0.75rem;
		font-weight: 600;
		line-height: 1;
		color: white;
		width: 37%;
	}

	.title-link {
		width: 63%;
		display: flex;
		text-transform: uppercase;
		font-size: 1.1rem;
		justify-content: flex-end;
		padding-right: 2rem;

		&-text {
			color: white;
			transition: 0.33s;

			&:hover {
				cursor: pointer;
				color: $white-op5;
			}

			&.selected {
				color: $white-op5;
			}
		}
	}
}

.divider-vertical {
	margin-left: 0.75rem;
	margin-right: 0.75rem;
	color: $white-op5;
}

.main {
	width: 100%;
	margin: 0 auto;
	position: relative;

	@media screen and (max-width: 768px) {
		background-size: 200% auto !important;
		background-position: 50% 0 !important;
	}

	&.maisy {
		background: url(../../public/img/maisy/haikei_maisy.jpg) repeat;
		background-size: 100% auto;
		background-position: 0 0;
		background-attachment: fixed;
	}

	&.refly {
		background: url(../../public/img/refly/haikei_refly.jpg) repeat;
		background-size: 100% auto;
		background-position: 0 0;
		background-attachment: fixed;
	}

	&.emekare {
		background: url(../../public/img/emekare/haikei_emekare.jpg) repeat;
		background-size: 100% auto;
		background-position: 0 0;
		background-attachment: fixed;
	}

}

label#menu {
	display: none;
}

#nav {
	display: none;
}

.bar-outer {
	display: none;
}

.bar {
	color: var(--pr-white);
	// text-transform: uppercase;
	font-size: calc(1.3 * var(--rem-vw));
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	max-width: 800px;
	height: calc(var(--bar-height) / 16 * var(--rem-vw));
	white-space: nowrap;
	position: relative;
	padding-top: 2rem;

	.divider {
		margin-top: 2rem;
		margin-bottom: 2rem;
	}

	.mre-link-bar {
		text-align: center;
		color: white;
		margin-top: 0.75rem;
		margin-bottom: 0.75rem;
		font-size: 1.8rem;
		font-weight: 600;
	}

	.uss {
		font-size: 0.4em;
	}

	.eme {
		font-size: 0.9em;
		margin-top: -0.3rem;
	}
}

.bar a {
	margin: 0;
	padding: 0;
	/* margin-top: 8px; */
	display: flex;
	margin-left: calc(0.5 * var(--rem-vw));
	align-items: center;
	flex: 1 1 auto;
	line-height: 1;
	color: var(--pr-white);
	height: 100%;
	font-weight: 600;
	position: relative;
	padding-top: 0.6rem;
}

.bar a:hover {
	color: var(--pr-darkblue);
}

.bar a.disabled {
	color: var(--pr-white-op5);
}

.bar a.disabled:hover {
	color: var(--pr-white-op5);
}

.bar a::after {
	position: relative;
	content: "";
	width: 100%;
	height: var(--bar-height);
	border-right: 1px solid var(--pr-white);
	margin-top: -0.6rem;
}

.bar a:last-child::after {
	border-right: none;
}

.js-loading *,
.js-loading *:before,
.js-loading *:after {
	animation-play-state: paused !important;
}

.loading {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.2rem;
	font-weight: 500;
	opacity: 1;
	color: var(--pr-gold);
	letter-spacing: 1px;
	z-index: 19;
	background-color: var(--pr-darkyellow);
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	text-transform: uppercase;
}

.blink {
	animation: blinker 0.5s ease-in-out alternate infinite;
	animation-play-state: running !important;
}

@keyframes blinker {
	0% {
		opacity: 0.5;
	}

	100% {
		opacity: 1;
	}
}

.bg-white {
	background: black;
	position: relative;
}

.bg2,
.bg3 {
	pointer-events: none;
}

.bg3,
.bg2 {
	/* background: url(../../public/img/prids_bg2.jpg) repeat-y; */
	background-size: var(--pr-bg-width) auto;
	background-position: right var(--pr-bg-margin) top;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	z-index: 1;
	position: absolute;
}

.bg2 {
	transform: scaleX(-1);
}

.main-visual-box {
	position: relative;
	width: calc(100vw - 8 * var(--rem-vw));
	height: calc((100vw - 8 * var(--rem-vw)) * 1.448);

	@media screen and (max-width: 768px) {
		width: 100vw;
		height: 144.8vw;
	}

	@media screen and (min-width:1024px) {
		max-width: calc(1024px - 8rem);
		height: calc((1024px - 8rem) * 1.448)
	}

	&-outer {
		z-index: 2;
		position: relative;
		background: radial-gradient(circle at center,
				$orange 0%,
				$liteorange 50%,
				$liteorange-op5 100%);

		&.refly {
			background: radial-gradient(circle at center,
					$liteblue 0%,
					$blue 25%,
					black 90%);
		}

		&.emekare {
			background: radial-gradient(circle at center,
					$litegreen 0%,
					$green 50%,
					$liteorange-op5 100%);
		}
	}
}

.page-goods-visual-box-outer {
	background: radial-gradient(ellipse 90% 100%,
			var(--pr-prids-bg) 0% 0%,
			var(--pr-black-bg) 60% 60%);
}

.page-goods-visual-box-outer {
	position: relative;
}

.page-goods-visual-box {
	width: 100%;
}

.main-visual-image {
	width: 100%;
	height: 100%;
	display: block;
	// animation: fadeIn 1s forwards ease-out 1;
	// opacity: 0;
	aspect-ratio: 1200 / 1697;
	position: absolute;
}


.main-visual-image-gradient {
	width: 100%;
	height: 144px;
	background: linear-gradient(to bottom, transparent 0%, var(--pr-yellow) 100%);
	background-size: 100% 144px;
	content: "";
	display: block;
	position: relative;
	top: -144px;
	bottom: 144px;
}

.d-none {
	display: none;
}

.prids-title-box {
	width: 100%;
	height: 117.19%;
	min-height: 117.19%;
	background: linear-gradient(to bottom,
			var(--pr-yellow) 0%,
			var(--pr-darkyellow) 100%);
	position: relative;
	margin-top: -144px;
}

.prids-logo-image {
	width: 32%;
	margin: 0 auto;
	display: block;
	top: -14.06vw;
	position: relative;
	aspect-ratio: 160 / 161;
}

.mre-links-box {
	display: flex;

	@media screen and (min-width: 1024px) {
		max-width: calc(1024px - 8rem);
	}

	&-outer {
		position: relative;
	}
}

.mre-link,
.mre-link-bar {
	flex: 1 1 50%;
	width: 50%;
	transition: 0.5s;
	position: relative;

	&::before {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		content: "";
		background: radial-gradient(white, $blue 105%);

		@media screen and (max-width: 768px) {
			background: radial-gradient(white 20%, $blue 100%);
		}
	}

	&-image {
		width: 60%;
		height: auto;
		margin: 1rem auto 2rem;
		position: relative;
		z-index: 2;

	}

	&::after {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		content: "";
		opacity: 0;
		transition: 0.5s opacity;
		background: radial-gradient(white, $liteblue 105%);
	}

	&:hover {
		cursor: pointer;

		&::after {
			opacity: 1;
		}
	}

	&.emekare {
		&:before {
			background: radial-gradient(white, $green 105%);

			@media screen and (max-width: 768px) {
				background: radial-gradient(white 20%, $green 100%);
			}
		}

		&::after {
			background: radial-gradient(white, $litegreen 105%);
		}
	}

	&.maisy {
		&:before {
			background: radial-gradient(white, $orange 105%);

			@media screen and (max-width: 768px) {
				background: radial-gradient(white 20%, $orange 100%);
			}
		}

		&::after {
			background: radial-gradient(white, $liteorange 105%);
		}

	}

}

.mre-link-bar {
	&::before {
		background: none;
	}

	&.emekare {
		&:before {
			background: none;
		}
	}

	&.maisy {
		&:before {
			background: none;
		}
	}
}

.mre-link-text {
	@media screen and (max-width: 768px) {
		width: 100%;
		background: none;
		color: white;
		font-size: 1.4rem;
		font-weight: 600;
		text-transform: uppercase;
		margin: 0 auto;
		padding: 1.5rem 0 1.2rem;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		filter: drop-shadow(0 0 6px black);

		&:hover {
			background: radial-gradient(white 20%, $liteorange 100%);

		}

		&.event {
			background: none;

			&:hover {
				background: radial-gradient(white 20%, $liteblue 100%);

			}
		}
	}
}

.mre-link-image {
	@media screen and (max-width: 768px) {
		width: 80%;
		height: auto;
		margin: 0.5rem auto 1.75rem;
		position: relative;
		z-index: 2;
	}

	&.in-bar-image {
		@media screen and (max-width: 768px) {
			width: 50%;
			filter: drop-shadow(0 0 3px black);
		}
	}
}

.mre-link-bar {
	// flex-direction: row;
	width: 100%;
	margin: 0 auto;

	.mre-link-image {
		margin-bottom: 1rem;
	}
}

.main-data-head {
	padding: 2px 8px;
	border: 5px solid $liteorange;
	display: inline-block;
	color: white;
	font-weight: 900;
	margin: 0 auto;
	font-size: 1.2 * $rem;
	pointer-events: visible;
	transition: 0.5s;
	position: relative;
	z-index: 2;

	&-text {
		@media screen and (max-width: 768px) {
			display: block;
			line-height: 1.2;
		}
	}

	@media screen and (min-width: 1024px) {
		font-size: 1.2rem;
	}

	@media screen and (max-width: 768px) {
		font-size: 1rem;
		width: 100%;
		padding: 4px;
	}

	&-outer {
		position: absolute;
		top: -1.2rem;
		width: 100%;
		pointer-events: none;

	}

	&.maisy {
		// color: $liteorange;
		border-color: $liteorange;
		background-color: $orange;
	}

	&.refly {
		// color: $liteblue;
		border-color: $liteblue;
		background-color: $blue;
	}

	&.emekare {
		// color: $litegreen;
		border-color: $litegreen;
		background: $green;
	}
}

.main-data-box {
	text-align: center;
	position: relative;
	padding-top: calc(2.5 * var(--rem-vw));
	margin-left: calc(50% - 50vw);
	margin-right: calc(50% - 50vw);
	padding-bottom: calc(1.5 * var(--rem-vw));
	transition: 0.5s;

	@media screen and (min-width: 1024px) {
		padding-top: 2.5rem;
		padding-bottom: 1.5rem;
	}
}

.main-data-title-text,
.main-data-dates-text,
.main-data-place-text,
.schedule-title-text,
.streaming-title-text,
.event-head-text,
.page-goods-title-text {
	color: white;
	// filter: brightness(1) drop-shadow(0 0 2px var(--pr-gold-boke)) drop-shadow(0 0 8px var(--pr-gold-boke));
}

.main-data-title-text {
	font-size: calc(var(--rem-vw) * 1.5);
	font-weight: 900;
	margin-bottom: var(--rem-vw);
}

.main-data-dates-text {
	font-size: calc(var(--rem-vw) * 3.6);
	font-weight: 400;
	color: white;

	@media screen and (min-width: 1024px) {
		font-size: 3.6rem;
	}

	@media screen and (max-width: 768px) {
		margin-top: 2rem;
	}
}

.schedule-date-box .dates-text {
	font-size: calc(var(--rem-vw) * 2.4);
	margin-top: 6rem;
}

.main-data-dates-text,
.main-data-place-text {
	filter: brightness(1) drop-shadow(0 0 1px white) drop-shadow(0 0 6px $white-op5);
}

.main-data-head-text {
	filter: drop-shadow(0 0 6px $white-op5);
}

.dates-text .day {
	font-size: 0.5em;
	margin: 0 0 0 -0.5rem;
}

.main-data-dates-text .to,
.dates-text .to {
	font-size: 0.4em;
	margin: 0 0.25rem;
}

.main-data-title-text .josefin {
	font-size: 1.1em;
	font-weight: 400;
}

.main-data-place-text {
	font-size: calc(var(--rem-vw) * 1.5);
	font-weight: 900;
	margin-bottom: var(--rem-vw);

	@media screen and (min-width: 1024px) {
		font-size: 1.5rem;
		margin-bottom: 1rem;
	}
}

.place-text {
	font-size: calc(var(--rem-vw) * 1.5);
	font-weight: 900;
	margin-bottom: var(--rem-vw);
	color: var(--pr-darkyellow);
	margin-top: 0.25rem;
	transition-duration: 0.33s;
}

.place-text a:hover {
	color: var(--pr-white);
}

.main-data-place-text.josefin,
.place-text.josefin {
	font-weight: 400;
}

.main-data-credits-text {
	font-size: calc(var(--rem-vw) * 1);
	color: white;

	// padding-bottom: calc(var(--rem-vw) * 1);
	@media screen and (min-width: 1024px) {
		font-size: 1rem;
		// padding-bottom: 1rem;
	}

	@media screen and (max-width:768px) {
		font-size: 0.9rem;
		padding-bottom: 0;
	}
}

.main-data-credits-text .smaller {
	font-size: 0.8em;
}

.flyer-link {
	margin: 1.5rem auto 0.5rem;
	filter: drop-shadow(0 0 4px white);

	@media screen and (max-width:768px) {
		margin-top: 1.25rem;
	}

	&-text {
		color: white;
		border-radius: 1.25rem;
		border: 1px solid white;
		padding: 0.25rem 2.5rem 0.35rem 2.5rem;
		// letter-spacing: 0.1em;
		transition: 0.33s;
		background-color: $orange;
		font-weight: 500;
		font-size: 1rem;

		&:hover {
			cursor: pointer;
			color: white;
			background-color: $liteorange;
			border-color: white;
		}
	}

	&.refly {
		.flyer-link-text {

			background-color: $blue;

			&:hover {
				color: $blue;
				border-color: $blue;
				background-color: $liteblue;
			}
		}
	}

	&.emekare {
		.flyer-link-text {

			background-color: $green;

			&:hover {
				color: $green;
				border-color: $green;
				background-color: $litegreen;
			}
		}
	}
}

.bg1-box {
	/* background: url(../../public/img/haikei_prids.jpg); */
	position: relative;
	z-index: 1;
}

.notice-window-bd {
	display: none;
	background-color: var(--pr-backdrop);
	position: fixed;
	top: 0;
	left: 0;
	z-index: 8;
	width: 100vw;
	min-height: 100vh;
	min-height: stretch;
}

.notice-window {
	display: flex;
	width: 80vw;
	height: 580px;
	max-height: 80vh;
	position: fixed;
	top: 15vh;
	left: 10vw;
	background-color: var(--pr-white);
	color: $black;
	border: 1px solid var(--pr-prids-bg);
	border-radius: 0.5rem;
	padding: 0;
	font-size: 1rem;
	line-height: 1.6;
	flex-direction: column;
}

.notice-window-close-button {
	justify-self: center;
	margin-top: auto;
	position: absolute;
	bottom: 1rem;
	right: 2rem;
}

.notice-window-close-link {
	padding: 0 0.5rem;
	margin: 0 -0.5rem;
	line-height: 1;
	font-size: 2.2rem;
	font-weight: 400;
	border-radius: 2rem;
}

.notice-inner {
	padding: 4rem 4rem;
	overflow-y: auto;
}

.notice-title {
	font-size: 1rem;
	font-weight: 500;
	color: $black;
	margin-bottom: 1rem;
}

.notice-body-text,
.notice-caution {
	padding-top: 1rem;
}

.notice-body-text,
.notice-head,
.notice-caution {
	font-size: 0.8rem;
}

.notice-head,
.notice-caution {
	font-weight: 400;
	margin-top: 1rem;
}

.notice-body-text {
	line-height: 1.6;
	font-weight: 400;
}

.notice-body-text ul {
	margin-left: 0.9rem;
}



/* news */
.news {
	position: relative;
	min-height: 240px;
}

.double-divider {
	border-top: 2px solid var(--pr-gold);
	border-bottom: 2px solid var(--pr-gold);
	height: 9px;
	width: 100%;
}

.double-divider.wide {
	width: 100vw;
	margin-left: calc(50% - 50vw);
	margin-right: calc(50% - 50vw);
	z-index: 1;
	position: relative;
}



.notice-link-box,
.streaming-box {
	text-align: center;
	font-size: 1rem;
	transition-duration: 0.33s;
	margin-left: calc(50% - 50vw);
	margin-right: calc(50% - 50vw);
	// background-color: #ffffff88;
	padding-top: 2rem;
	padding-bottom: 2rem;

	@media screen and (max-width: 768px) {
		padding-top: 1rem;
		padding-bottom: 1rem;
	}

	.inner {
		padding: 0.5rem 4rem 0.5rem;

		@media screen and (max-width: 768px) {
			padding-left: 1rem;
			padding-right: 1rem;
		}
	}
}

.streaming-box {
	.inner {
		padding: 0.5rem 3rem;
		color: $black;

		@media screen and (max-width: 768px) {
			padding-left: 1rem;
			padding-right: 1rem;
		}
	}
}

.streaming-title {
	text-transform: uppercase;
	font-size: 2.6rem;
	margin-top: -0.25rem;
	margin-bottom: 1rem;

	@media screen and (max-width: 768px) {
		font-size: 1.7rem;
		margin-bottom: -0.7rem;
		margin-top: 0rem;
	}

	.streaming-head {
		line-height: 1.7;
		font-weight: 600;
		color: $orange;

		&.refly {
			color: $blue;
		}

		&.emekare {
			color: $green;
		}

		.copy {
			font-size: 1.1rem;

			@media screen and (max-width: 768px) {
				font-size: 0.8rem;
				margin-bottom: 0;
			}
		}

		.text {
			text-transform: uppercase;
			font-size: 2.6rem;
			margin-top: -0.25rem;
			margin-bottom: -1.4rem;

			@media screen and (max-width: 768px) {
				font-size: 1.7rem;
				margin-bottom: -0.7rem;
				margin-top: 0rem;
			}
		}
	}
}

.streaming-border {
	padding: 2rem 4rem;

	.data-text {
		line-height: 1.7;
		margin-top: 3rem;

		@media screen and (max-width: 768px) {
			margin-top: 3rem;
		}


		.streaming-url {
			font-weight: 600;
		}

		.streaming-link {
			margin-top: 0.5rem;

			.text {
				background-color: $orange;
				color: white;
				border-radius: 1.5rem;
				padding: 0.25rem 1rem;
				font-weight: 600;
				transition: 0.33s;

				&:hover {
					background-color: white;
					color: $orange;
					cursor: pointer;
				}
			}

			&.a-refly {
				.text {
					background-color: $blue;

					&:hover {
						background-color: white;
						color: $blue;
					}
				}
			}

			&.a-emekare {
				.text {
					background-color: $green;

					&:hover {
						color: $green;
						background-color: white;
					}
				}
			}
		}

		&.a-refly {
			a {
				color: $blue;

				&:hover {
					&:hover {
						color: black;
					}
				}
			}

		}

		&.a-emekare {
			a {
				color: $green;

				&:hover {
					color: black;
				}
			}

		}
	}
}

.notice-link-text,
.streaming-border {
	position: relative;
	border: 8px solid $liteorange;
	display: block;
	transition: 0.33s;

	border-image: url(../../public/img/mre_menu.png);
	border-image-slice: 1;

	@media screen and (max-width: 768px) {
		padding: 1rem 0rem !important;
	}
}

.notice-link-text {
	padding: 1rem 4rem;
	background-color: white;

	&:hover {
		cursor: pointer;
		// border-width: 2rem;
		background: url(../../public/img/mre_menu.png);
		background-size: 100% auto;
		border-image: none;
		border-color: white;
		color: white !important;
		filter: brightness(110%);

		.notice-text-add {
			color: white;
		}
	}
}

.notice-text {
	text-align: center;
	font-size: 1.1rem;
	font-weight: 700;
	letter-spacing: 0.2em;

	@media screen and (max-width: 768px) {
		letter-spacing: normal;
	}

	.en {
		text-transform: uppercase;
		font-size: 1.2em;
		transform: translateY(1.5px);
		display: inline-block;
	}

	&-add {
		font-size: 0.8em;
		color: $black;
		letter-spacing: 0.1em;
	}
}

.streaming-text {
	color: $black;
}

.news-outer {
	margin-left: calc(50% - 50vw);
	margin-right: calc(50% - 50vw);
	background-color: #ffffff88;
}

.title-text {
	font-size: 2.5rem;
	text-align: center;
	padding-top: 2rem;
	padding-bottom: 0.5rem;
	font-weight: 600;
	line-height: 1;
}

.guide-title {
	position: relative;
}

.info-title {
	color: $liteorange;
	transition: 0.5s;

	&.refly {
		color: $liteblue;
	}

	&.emekare {
		color: $litegreen;
	}
}

.news-info-box {
	padding: 0rem 4rem 0;
	position: relative;
}

.news-item-outer:first-child {
	border-top: 1px dotted currentColor;
}

.news-item-outer {
	position: relative;
	will-change: height;
	backdrop-filter: none;
	-webkit-backdrop-filter: none;
}

.news-item {
	font-weight: 300;
	border-bottom: 1px dotted currentColor;
	padding-top: 0.15rem;
	padding-bottom: 0.15rem;
	position: relative;
}

.news-divider+.news-item {
	border-top-color: black;
}

.news-divider {
	padding-bottom: 1.5rem;
}

.news-text strong {
	font-weight: 900;
}

.news-text em {
	font-style: normal !important;
	color: var(--pr-darkyellow) !important;
}

.news-head {
	padding: 0;
	display: flex;
	align-items: flex-start;
	padding-bottom: 0.3rem;
	padding-top: 0.3rem;
	position: relative;
	transition-duration: 0.33s;
}

.news-item .news-head:hover {
	color: white;
	cursor: pointer;
	background-color: var(--pr-backdrop);
}

.news-item.closed .news-head::after {
	transform: rotate(180deg);
}

.news-head.foldable::after {
	width: 6px;
	height: 7px;
	position: absolute;
	border-bottom: 9px solid currentColor;
	border-right: 6px solid transparent;
	border-left: 6px solid transparent;
	right: 12px;
	bottom: 13px;
	content: "";
	transition-duration: 0.33s;
	transition-property: transform, border-color;
	transform-origin: center 6px;
	z-index: 0;
}

.news-head.foldable {

	// border-bottom-color: currentColor;
	&.maisy:hover::after {
		border-bottom-color: $orange;
	}

	&.refly:hover::after {
		border-bottom-color: $blue;
	}

	&.emekare:hover::after {
		border-bottom-color: $green;
	}
}

.news-date {
	font-size: 0.8rem;
	padding: 0.2rem 0.5rem 0 0;
	margin-top: 0.1rem;
	font-weight: 600;
	line-height: 1;
	letter-spacing: 0;
	white-space: nowrap;
	display: flex;
	align-items: center;
	transition: 0.33s;
}

.new-tick {
	color: var(--pr-white);
	padding: 0;
	border-radius: 2px;
	margin: 0 0 0.1rem 0.5rem;
	padding: 0.2rem 0.2rem 0;
	font-size: 0.7rem;
	font-weight: 700;
	display: inline-block;
	letter-spacing: -0.5px;
	transition-duration: 0.33s;

	&.maisy {
		background-color: $liteorange;
	}

	&.refly {
		background-color: $liteblue;
	}

	&.emekare {
		background-color: $litegreen;
	}
}

.news-head:hover .new-tick {
	&.maisy {
		background-color: $orange;
	}

	&.refly {
		background-color: $blue;
	}

	&.emekare {
		background-color: $green;
	}
}

.news-title {
	color: $black;
	font-size: 1rem;
	font-weight: 600;
	transition-duration: 0.33s;
	transition-property: color;
	padding: 0 1.5rem 0 0;
	line-height: 1.3;
	margin-right: 0.5rem;

	@media screen and (max-width:768px) {
		padding-right: 0;
		margin-right: 0;
		text-align: left;
	}
}

.news-head:hover .news-date,
.news-head:hover .news-title {
	&.maisy {
		color: $orange;
	}

	&.refly {
		color: $blue;
	}

	&.emekare {
		color: $green;
	}
}

.news-text-box {
	padding: 0;
	margin: 0;
	position: relative;
}

.news-text {
	font-size: 0.9rem;
	color: $black;
	transition-duration: 0.33s;
	transition-property: color;
	padding: 1rem 3rem;
	line-height: 1.7;
	border-top: none;
	font-weight: 400;
	margin-bottom: 0.5rem;

}



.news-text p {
	margin: 0;
	min-height: 16px;
}

.news-text a:hover {
	color: var(--pr-white);
}

.more-box {
	min-height: 30px;
}

.news-more {
	font-size: 0.8rem;
	font-weight: 600;
	padding-top: 1rem;
	padding-bottom: 1rem;
	appearance: normal;
	-webkit-appearance: normal;
	border: none;
	background-color: transparent;
	margin: 0 auto;
	text-align: center;
	text-transform: uppercase;
	display: block;
	transition-property: color;
	transition-duration: 0.33s;
}

.news-more:hover {
	cursor: pointer;
}

.toggle-slide-enter-active,
.toggle-slide-leave-active {
	transition: height 0.4s;
	overflow: hidden;
}

.toggle-slide-enter,
.toggle-slide-leave-to {
	height: 0;
	transition: height 0.4s;
}

.slide-fade-enter-active {
	transition: all 0.33s ease;
}

.slide-fade-leave-active {
	transition: all 0.33s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
	transform: translateY(-10px);
	opacity: 0;
}

.cast-outer {
	position: relative;
}

.story-box::before {
	background-position: 0.5rem 1.5rem 0;
}

.cast-bg::before {
	transform: scale(-1, 1);
	width: 100%;
	max-width: var(--pc-width);
	z-index: 1;
}

.staff-box::before {
	left: 0;
	overflow: visible;
	z-index: 4;
}

.goods-box::before {
	top: 32px;
}

.cast-outer {
	position: relative;

	&::after {
		background: url(../../public/img/maisy/logo_maisy.png) no-repeat;
		background-size: contain;
		content: "";
		width: calc(700 / 1024 * 75vw);
		height: calc(263 / 1024 * 75vw);
		position: absolute;
		top: -5%;
		left: $rem;
		z-index: 1;

		@media screen and (min-width: 1024px) {
			background: url(../../public/img/maisy/logo_maisy.png) no-repeat;
			background-size: contain;
			width: calc(700px * 0.75);
			height: calc(263px * 0.75);
			left: 1rem;
		}

		@media screen and (max-width: 768px) {
			background: url(../../public/img/maisy/logo_maisy.png) no-repeat;
			background-size: contain;
			width: calc(700px * 0.33);
			height: calc(263px * 0.33);
			top: -1%;
			left: 0;
			z-index: 3;
		}
	}

	&.refly::after {
		background: url(../../public/img/refly/logo_refly.png) no-repeat;
		background-size: contain;
	}

	&.emekare::after {
		background: url(../../public/img/emekare/logo_emekare.png) no-repeat;
		background-size: contain;
	}
}



.staff-title,
.cast-title,
.intro-title,
.story-title,
.goods-title {
	font-size: calc(2.6 * var(--rem-vw));
	text-align: center;
	margin-left: 4rem;
	padding-top: 4rem;
	font-weight: 600;

	@media screen and (min-width: 1024px) {
		font-size: 2.6rem;
	}
}

.intro-title {
	padding-top: 5rem;
}

.story-title {
	padding-top: 5rem;

	.smaller {
		font-size: 0.6em;
	}
}

.cast-outer,
.staff-title,
.goods-title {
	&.maisy {
		color: $orange;
	}

	&.refly {
		color: $blue;
	}

	&.emekare {
		color: $green;
	}
}

.staff-title {
	text-align: left;
	padding-top: 3rem;
}

.batsu {
	display: inline;
	height: 0.7em;
	margin-left: 0.2rem;
	margin-right: 0.2rem;
}

.news-inner,
.intro-title,
.story-title,
.goods-title {
	position: relative;
	color: $orange;

	&::before,
	&::after {
		position: absolute;
		content: "";
		background: url(../../public/img/maisy/title_maisy.png) no-repeat;
		width: 44px;
		height: 68px;
		bottom: 0;
		left: 4 * $rem;

		@media screen and (min-width: 1024px) {
			left: 4rem;
		}

		@media screen and (max-width: 768px) {
			left: 0;
			background-size: calc(44px * .8) calc(68px * .8);
			height: calc(68px * .8);
		}
	}

	&.refly {
		color: $blue;

		&::before,
		&::after {
			background: url(../../public/img/refly/title_refly.png) no-repeat;
			width: 44px;
			height: 68px;
			bottom: 0;
			left: 4 * $rem;

			@media screen and (min-width: 1024px) {
				left: 4rem;
			}

			@media screen and (max-width: 768px) {
				left: 0;
				background-size: calc(44px * .8) calc(68px * .8);
				height: calc(68px * .8);
			}
		}
	}

	&.emekare {
		color: $green;

		&::before,
		&::after {
			background: url(../../public/img/emekare/title_emekare.png) no-repeat;
			width: 44px;
			height: 68px;
			bottom: 0;
			left: 4 * $rem;

			@media screen and (min-width: 1024px) {
				left: 4rem;
			}

			@media screen and (max-width: 768px) {
				left: 0;
				background-size: calc(44px * .8) calc(68px * .8);
				height: calc(68px * .8);
			}
		}
	}

	&.refly::after,
	&.emekare::after,
	&::after {
		transform: scaleX(-1);
		right: 4 * $rem;
		left: unset;

		@media screen and (min-width: 1024px) {
			right: 4rem;
		}

		@media screen and (max-width: 768px) {
			right: 0;
		}
	}

}

.news-inner::before,
.news-inner::after {
	@media screen and (max-width: 768px) {
		bottom: -5px;
	}
}

.intro-title,
.story-title,
.goods-title {
	margin-left: 0;

	@media screen and (max-width: 768px) {
		margin-left: 0;
		padding-bottom: 0.75rem;
		padding-top: 2.5rem;
		font-size: 1.6rem;
		margin-top: 0.5rem;
	}

	.jp {
		font-size: 0.45em;
		letter-spacing: 0.1em;
		margin-bottom: -2rem;
		font-weight: 600;

		@media screen and (max-width: 768px) {
			margin-bottom: -1rem;
		}
	}

	&::before,
	&::after {
		bottom: 12px !important;
	}
}

.intro-title {
	@media screen and (max-width: 768px) {
		padding-top: 5.5rem;
	}
}

.story-title,
.goods-title {

	&::before,
	&::after {
		bottom: 0 !important;
	}
}

.info-title {
	text-align: center;
	margin-bottom: 2rem;

}

.cast-title {
	text-align: right;
	margin-right: 3rem;
	margin-left: 0;
	margin-bottom: 1.5rem;
	margin-top: 1.5rem;
	padding-top: 1rem;
}

.cast {
	position: relative;
	z-index: 2;
}

.cast-outer {
	position: relative;
}

.cast-list {
	padding: 0 4rem;
}

.unit-name-text {
	padding: 0.5rem 0.5rem 0.1rem;
	margin-right: 3rem;
	text-align: right;
	color: white;
	font-size: 1.7 * $rem;
	font-weight: 700;
	z-index: 92;

	@media screen and (min-width: 1024px) {
		font-size: 1.7rem;
	}
}

.unit-name-text.maisy {
	background: linear-gradient(to right, transparent 50%, $liteorange);
}

.unit-name-text.refly {
	background: linear-gradient(to right, transparent 50%, $liteblue);
}

.unit-name-text.emekare {
	background: linear-gradient(to right, transparent 50%, $litegreen);
	font-size: 1 * $rem;
	padding: 0.1rem 0.5rem 0.1rem;

	@media screen and (min-width: 1024px) {
		font-size: 1rem;
	}

	@media screen and (max-width: 768px) {
		font-size: 1rem;
		padding: 0.4rem 0.5rem 0.3rem;
	}
}

.cast-list-box {
	padding: 0.5rem 3 * $rem 1rem;
	color: $black;
	display: flex;
	flex-wrap: wrap;
	margin-top: 1rem;
	// justify-content: center;

	@media screen and (min-width: 1024px) {
		padding-left: 3rem;
		padding-right: 3rem;
	}
}

.cast-guest {
	font-size: 1.1rem;
	margin-bottom: 4rem;
	margin-top: 1rem;
	color: $grey;
	text-align: left;
	padding-left: 3rem;
	padding-right: 3rem;

	@media screen and (max-width: 768px) {
		margin-top: 1rem;
		margin-bottom: 3rem;
		font-size: 1rem;
		text-align: center;
		padding: 0;
	}

	&-text {
		padding: 0.12rem 0.75rem;
		border: 3px solid white;

		@media screen and (max-width: 768px) {
			padding: 0.12rem 0.75rem 0.2rem;
		}
	}

	.unit-name {
		font-weight: 700;
		font-size: 1.1em;
		color: white;
	}


}

.cast-list.hotblood {
	text-align: right;
}

.cast-list-box.hotblood .cast-list-item {
	display: inline;
	margin-right: 1.5rem;
}

.cast-list-box.hotblood .cast-list-item:last-child {
	margin-right: 0;
}

.cast-list-item {
	padding: 0.2rem 0;
	font-size: calc(1.1 * var(--rem-vw));
	line-height: 1.4;
	display: flex;
	flex-direction: column;
	align-items: center;
	color: var(--pr-grey);
	flex: 0 1 20%;
	width: 20%;
	margin-top: 2rem;
	margin-bottom: 1rem;

	@media screen and (max-width: 768px) {
		font-size: 0.9rem;
		width: 33.3%;
		flex: 0 1 33.3%;
		width: 300px;
		margin-bottom: 0.5rem;
		margin-top: 1rem;

		&:first-child {
			margin-left: 0;
		}
	}
}

.cast-list-item:first-child {
	margin-left: auto;
}

.cast-list-item>.character {
	margin-top: 0.5rem;


}

.cast-image-box {
	padding-left: 0.75rem;
	padding-right: 0.75rem;
}

.cast-list-box {
	margin-left: calc(-0.75rem + 3px);
	margin-right: calc(-0.75rem + 3px);
}

.cast-image {
	width: 100%;
	height: 100%;
	aspect-ratio: 1 / 1;
	box-shadow: 0 0 0 3px currentColor;
}

.maisy.cast-image {
	box-shadow: 0 0 0 3px $liteorange;
}

.cast-list-box.hotblood .cast-list-item {
	font-size: calc(1.2 * var(--rem-vw));
}

.cast-list-item .actor {
	font-size: 1.2em;
}

.staff-box,
.story-box {
	position: relative;
	z-index: 1;
	padding-bottom: 8px;
}

.staff-divider,
.story-divider {
	border-top: 2px dotted var(--pr-darkyellow);
	width: 100%;
	margin-left: 0;
	margin-right: 0;
	margin-bottom: 2rem;
}

.story-divider {
	margin-bottom: 2rem;
	margin-top: 2rem;
	margin-left: -16rem;
	width: calc(100% + 20rem);
}

.staff-text {
	margin-top: -3.5rem;
	padding-left: 16rem;
	line-height: 1.8;
	padding-bottom: 4rem;
	color: var(--pr-grey);
}

.story-text {
	font-size: 1 * $rem;

	@media screen and (min-width: 1024px) {
		font-size: 1rem;
	}
}

.staff-text {
	text-align: left;
	font-size: 1 * $rem;
	line-height: 1.7;

	@media screen and (min-width: 1024px) {
		font-size: 1rem;
	}

	&-music {
		clear: both;
		margin: 0;

		dt {
			float: left;
		}

		dd {
			padding-left: 0.5rem;
		}
	}
}

.intro-text,
.story-text {
	font-weight: 600;
}

.story-text-box {
	margin-top: 1.5rem;
	line-height: 1.8;
	padding-bottom: 4rem;
	color: var(--pr-grey);
	padding-right: 4rem;
	padding-left: 4rem;
	text-align: left;

	@media screen and (max-width: 768px) {
		padding-left: 1rem;
		padding-right: 1rem;
		padding-bottom: 2rem;
	}

	&.intro {
		margin-top: 2.25rem;
		padding-bottom: 4rem;
	}
}



.bg-black {
	background: linear-gradient(to right,
			transparent 0%,
			transparent calc(var(--pr-bg-width) + var(--pr-bg-margin)),
			black calc(var(--pr-bg-width) + var(--pr-bg-margin)),
			black calc(100% - calc(var(--pr-bg-width) + var(--pr-bg-margin))),
			transparent calc(100% - calc(var(--pr-bg-width) + var(--pr-bg-margin))),
			transparent 100%);
	position: relative;
}

.schedule-box {
	z-index: 2;
}

.schedule-box,
.ticket-box,
.streaming-box {
	padding-top: 2rem;
	position: relative;
	padding-bottom: 4rem;
}

.ticket-box {
	padding-bottom: 2.5rem;
}

.goods-box {
	padding-top: 6px;
	padding-bottom: 1rem;
}

.schedule-title-box,
.streaming-title-box,
.page-goods-title {
	text-align: center;
}

.page-goods-title {
	position: relative;
	padding-bottom: 3rem;
}

.info-title {
	position: relative;
}

.schedule-title-text,
.streaming-title-text,
.goods-title-text,
.page-goods-title-text {
	font-size: calc(2.6 * var(--rem-vw));
	font-weight: 400;
}

.schedule-date-box {
	text-align: center;
	color: white;
}

.schedule-table-box {
	color: white;
	width: 72.5%;
	margin: 0 auto;
}

.schedule-table {
	border-spacing: 4px;
	width: 100%;
}

.schedule-table .rest {
	background-color: black;
	color: var(--pr-prids-bg);
}

.schedule-table .schedule-time.rest {
	text-align: center;
	font-weight: 300;
}

.schedule-table .holiday {
	padding-right: 0.2rem;
}

.schedule-date,
.schedule-time {
	background-color: var(--pr-prids-bg);
	color: black;
	font-weight: 600;
	font-size: calc(1.3 * var(--rem-vw));
}

.schedule-date {
	width: 34%;
	padding-right: 2rem;
	text-align: right;
}

.schedule-time {
	width: 16%;
	text-align: center;
	font-weight: 400;
	overflow-x: visible;
}

.schedule-time.empty {
	background-color: var(--pr-darkyellow2);
}

.eplus-day {
	color: var(--pr-eplus-pink);
}

.eplus-desc {
	margin-top: 1rem;
	font-size: 0.8rem;
	line-height: 1.6;
	transition-duration: 0.33s;
	padding-left: 1rem;
	padding-right: 1rem;
	filter: drop-shadow(0 0 3px var(--pr-black-bg));
}

.event-box {
	z-index: 2;
	position: relative;
	margin-bottom: 4rem;
}

.event-box-inner {
	padding-left: 4rem;
	padding-right: 4rem;
	width: 100%;
}

.event-head {
	background: linear-gradient(to right,
			var(--pr-prids-bg) -5rem,
			transparent 30%,
			transparent 70%,
			var(--pr-prids-bg) 100%);
	text-align: center;
	font-weight: 400;
	font-size: calc(1.8 * var(--rem-vw));
	line-height: 1;
	color: var(--pr-white);
	margin-bottom: 1rem;
	margin-top: 2rem;
	text-transform: uppercase;
}

.event-head1 {
	color: white;
	text-align: center;
	font-size: calc(1 * var(--rem-vw));
}

.event-border {
	border: 1px solid var(--pr-darkyellow-op5);
	padding: 2rem 5rem;
	margin-top: 2rem;
	margin-bottom: 2rem;
	position: relative;
	background-color: var(--pr-black-op5);
	z-index: 1;
}

.event-border::after {
	content: "";
	position: absolute;
	/* background: url(../../public/img/event_kado.svg) no-repeat; */
	background-position: right top;
	background-size: 110px;
	width: 110px;
	height: 110px;
	top: -12px;
	right: -12px;
	z-index: 1;
}

.event-head2 {
	background: linear-gradient(to right,
			var(--pr-prids-bg) 0%,
			var(--pr-prids-bg) 20%,
			transparent 100%);
	color: black;
	font-weight: 700;
	font-size: calc(1.1 * var(--rem-vw));
	padding: 0.1rem 0.5rem 0.2rem;
	margin-bottom: 1rem;
	margin-top: 2.5rem;
}

.event-head3 {
	font-weight: 700;
	color: var(--pr-prids-bg);
	font-size: calc(1 * var(--rem-vw));
	margin-bottom: 0.25rem;
	margin-top: 0.5rem;
	z-index: 2;
	position: relative;
}

.event-head4 {
	color: var(--pr-prids-bg);
}

.event-datetime {
	font-weight: 700;
}

.mt-0 {
	margin-top: 0;
}

.mt-4 {
	margin-top: 1rem;
}

.mb-4 {
	margin-bottom: 1rem;
}

.divider-event-head,
.divider-event {
	border-top: 1px solid var(--pr-prids-bg);
	height: 1px;
	width: 100%;
	margin-top: 0.5rem;
	margin-bottom: 0.5rem;
}

.divider-event {
	border-top: 1px dotted var(--pr-darkyellow-op5);
}

.divider-event.wide,
.divider-event-head {
	margin-top: 1rem;
	margin-bottom: 1rem;
}

.event-text {
	font-size: calc(0.8 * var(--rem-vw));
	color: white;
	line-height: 1.7;
}

.event-tokuten-coaster-box {
	margin: 1rem auto 0.5rem 0;
	width: 66.66%;
}

.event-tokuten-coaster-image {
	width: 100%;
}

.event-tokuten-coaster-image.image2 {
	width: 66.66%;
	margin-top: 0.5rem;
}

.event-notice-list-head {
	color: var(--pr-prids-bg);
}

.event-notice-list {
	font-size: calc(0.8 * var(--rem-vw));
	line-height: 1.7;
	/* margin-top: 0.25rem; */
}

.event-schedule-head {
	text-align: center;
	color: var(--pr-prids-bg);
	font-size: calc(1.1 * var(--rem-vw));
	margin-top: 3rem;
	margin-bottom: 1rem;
	padding: 1rem;
	border: 1px solid var(--pr-prids-bg);
	position: relative;
	font-weight: 700;
	z-index: 2;
	transition-duration: 0.33s;
}

.event-schedule-head:hover {
	cursor: pointer;
	background-color: var(--pr-darkyellow-op5);
}

.event-schedule-head-inner {
	border: 1px solid var(--pr-prids-bg);
	border-right: 0;
	border-left: 0;
	position: absolute;
	width: calc(100% + 2px);
	height: calc(100% - 12px);
	content: "";
	left: -1px;
	right: -1px;
	top: 6px;
	bottom: 6px;
}

.event-schedule-head::after,
.page-goods-all-notice::after {
	position: absolute;
	top: -1px;
	bottom: 0;
	width: 64px;
	height: 64px;
	content: "";
	left: -8px;
	/* background: url(../../public/img/event_yoko.svg) no-repeat; */
	transform: scaleX(-1);
	z-index: -1;
}

.page-goods-all-notice::after {
	/* background: url(../../public/img/goods_yoko.svg) no-repeat; */
	top: 1.7rem;
}

.event-schedule-head::before {
	/* background: url(../../public/img/event_yoko.svg) no-repeat; */
	background-size: 64px;
	width: 64px;
	height: 64px;
	position: absolute;
	content: "";
	right: -8px;
	top: -1px;
	z-index: -1;
}

.event-schedule-head-inner::after {
	content: "";
	position: absolute;
	width: 8px;
	height: 9px;
	position: absolute;
	border-bottom: 9px solid var(--pr-darkyellow);
	border-right: 8px solid transparent;
	border-left: 8px solid transparent;
	right: 72px;
	top: 18px;
	content: "";
	transition-duration: 0.33s;
	transition-property: transform, border-color;
	transform-origin: center 5px;
	z-index: 0;
}

.event-schedule-head-inner.closed::after {
	transform: rotate(180deg);
}

.event-schedule-list {
	color: white;
	font-size: calc(0.8 * var(--rem-vw));
}

.event-schedule-notice,
.ticket-price-notice {
	font-size: calc(0.8 * var(--rem-vw));
	color: white;
	margin-top: 1rem;
}

.ticket-price-notice {
	padding-left: 9rem;
	padding-right: 9rem;
	text-align: center;
}

.ticket-price-notice li {
	margin-bottom: 1rem;
}

.ticket-box,
.streaming-box {
	color: white;
	position: relative;
	z-index: 2;
}

.ticket-price-text {
	font-size: calc(1.2 * var(--rem-vw));
	color: white;
	margin-top: 6rem;
	text-align: center;
	font-weight: 600;
	margin-bottom: 1rem;
}

.ticket-price-title {
	color: var(--pr-prids-bg);
	font-size: calc(1.1 * var(--rem-vw));
}

.ticket-price-taxin {
	font-size: 0.8em;
}

.ticket-head,
.page-goods-head {
	background: linear-gradient(to right,
			transparent 0%,
			var(--pr-prids-bg) 20%,
			var(--pr-prids-bg) 80%,
			transparent 100%);
	text-align: center;
	font-weight: 700;
	font-size: calc(1.1 * var(--rem-vw));
	padding-bottom: 0.2rem;
	padding-top: 0.1rem;
	color: black;
	margin-bottom: 2rem;
	margin-top: 3rem;
	margin-left: -5rem;
	margin-right: -5rem;
}

.ticket-head.playguide {
	margin-top: 3rem;
}

.ticket-head.webflyer {
	width: 15%;
	margin: 0 auto;
	font-size: calc(1 * var(--rem-vw));
	background: none;
	border-radius: 1rem;
	border: 1px solid var(--pr-white);
	transition-duration: 0.33s;
	position: relative;
	padding: 0;
	color: var(--pr-white);
	display: block;
	filter: brightness(1) drop-shadow(0 0 2px var(--pr-gold-boke)) drop-shadow(0 0 8px var(--pr-gold-boke));
}

.ticket-head.webflyer a {
	color: var(--pr-white);
	display: block;
	padding: 0.25rem 0.5rem 0.4rem;
	border-radius: 1rem;
}

.ticket-head.webflyer a:hover {
	color: var(--pr-gold);
	background-color: var(--pr-white);
}

.ticket-box-inner,
.streaming-box-inner {
	padding-left: 9rem;
	padding-right: 9rem;
}

.ticket-notice-pre {
	font-size: calc(0.8 * var(--rem-vw));
}

.ticket-item,
.streaming-item {
	margin-top: 2rem;
	line-height: 1.8;
	font-size: calc(1 * var(--rem-vw));
}

.ticket-head2,
.streaming-head2 {
	font-weight: 600;
	font-size: calc(1 * var(--rem-vw));
}

.streaming-head2 {
	margin-top: 1rem;
}

.ticket-head2>.head2-sq,
.streaming-head2>.head2-sq {
	color: var(--pr-prids-bg);
}

.ticket-data-url.eplus {
	margin-top: 2rem;
}

.eplus-name {
	font-weight: 600;
}

.ticket-data-url a,
.ticket-resale a,
.streaming-data-url a {
	transition-duration: 0.33s;
}

.ticket-data-url a:link,
.ticket-data-url a:visited,
.ticket-resale a:link,
.ticket-resale a:visited,
.streaming-data-url a:link,
.streaming-data-url a:visited {
	color: $orange;
}

.ticket-data-url a:hover,
.ticket-resale a:hover,
.streaming-data-url a:hover {
	color: var(--pr-white);
}

.ticket-data-date,
.streaming-data-date {
	font-size: calc(1 * var(--rem-vw));
}

.ticket-data-desc,
.streaming-data-desc {
	font-size: calc(0.85 * var(--rem-vw));
}

.ticket-notices-box {
	margin-left: 4rem;
	margin-right: 4rem;
	width: calc(100% - 8rem);
}

.ticket-resale {
	margin-top: 5rem;
	border: 2px solid var(--pr-darkyellow-op5);
	position: relative;
	background-color: var(--pr-black-op5);
}

.ticket-resale-head {
	text-align: center;
	font-weight: 600;
	cursor: pointer;
	color: var(--pr-prids-bg);
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
	transition-duration: 0.33s;
	font-size: var(--rem-vw);
}

.ticket-resale-head:hover,
.ticket-notice-head:hover {
	background-color: var(--pr-darkyellow-op5);
}

.ticket-resale-text {
	padding: 1.5rem 3rem 2rem;
	display: none;
	font-size: var(--rem-vw);
}

.ticket-resale-text a {
	word-break: break-all;
}

.ticket-resale-desc,
.ticket-resale-list {
	font-size: calc(0.8 * var(--rem-vw));
	line-height: 1.7;
}

.ticket-resale-list {
	margin-top: 2rem;
	line-height: 1.7;
}

.ticket-notice-box {
	border: 2px solid var(--pr-darkyellow-op5);
	margin-top: 2rem;
	background-color: var(--pr-black-op5);
	z-index: 2;
	position: relative;
}

.ticket-notice-head {
	color: var(--pr-prids-bg);
	font-size: calc(1 * var(--rem-vw));
	font-weight: 600;
	text-align: center;
	letter-spacing: 0.5rem;
	cursor: pointer;
	padding: 0.5rem 0;
	transition-duration: 0.33s;
}

.ticket-notice-head::after,
.ticket-resale-head::after {
	content: "";
	position: absolute;
	width: 8px;
	height: 9px;
	position: absolute;
	border-bottom: 9px solid var(--pr-darkyellow);
	border-right: 8px solid transparent;
	border-left: 8px solid transparent;
	right: 14px;
	top: 15px;
	content: "";
	transition-duration: 0.33s;
	transition-property: transform, border-color;
	transform-origin: center 5px;
	z-index: 0;
}

.ticket-notice-head.closed::after,
.ticket-resale-head.closed::after {
	transform: rotate(180deg);
}

.ticket-notice-text {
	margin-top: 1.5rem;
	display: none;
	padding-left: 3rem;
	padding-right: 3rem;
	padding-bottom: 1.5rem;
}

.ticket-notice-text li,
.page-goods li {
	font-size: calc(0.85 * var(--rem-vw));
	margin-bottom: 0.3rem;
	line-height: 1.7;
}

.ticket-info-total {
	margin-top: 2rem;
	text-align: center;
	line-height: 1.8;
	font-size: var(--rem-vw);
}

.ticket-info-total-head {
	font-weight: 600;
}

.space-nowrap {
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}

.goods-link-button-outer {
	border: 2px solid var(--pr-gold);
	padding: 4px;
	margin-left: -12rem;
	transition-duration: 0.33s;
}

.goods-link-button-outer:hover {
	border-color: var(--pr-gold);
	background-color: var(--pr-yellow-bg);
}

.goods-link-button {
	border: 2px solid var(--pr-gold);
	text-align: center;
	padding: 0.5rem 0;
	font-size: 1rem;
	font-weight: 600;
	color: var(--pr-gold);
	line-height: 1.1;
	transition-duration: 0.33s;
	background-color: var(--pr-darkyellow);
}

.goods-link-button-outer:hover .goods-link-button {
	cursor: pointer;
	background-color: transparent;
	border-color: transparent;
}

.goods-link-text-en {
	font-size: 1.9em;
	transform: translateY(0.25rem);
}

.goods-link-text-jp {
	font-size: 1rem;
	color: $black;
	font-weight: 400;
	transition-duration: 0.33s;
}

.goods-link-button-outer:hover .goods-link-text-jp {
	color: var(--pr-gold);
}

.page-notice {
	padding-top: 2rem;
}

.page-notice a:link,
.page-notice a:visited,
.page-goods a:link,
.page-goods a:visited {
	color: $orange;
	font-weight: 600;
}

.page-notice a:hover,
.page-goods a:hover {
	color: var(--pr-white);
}

.page-notice li {
	margin-top: 0.2rem;
	margin-bottom: 0.2rem;
}

.page-notice-box {
	padding-left: 4rem;
	padding-right: 4rem;
}

.page-notice-title {
	font-size: 1.1rem;
	text-align: center;
	font-weight: 600;
	line-height: 1.5;
	padding-top: 2rem;
}

.page-notice-text-box {
	font-size: 0.85rem;
	margin-top: 3rem;
	line-height: 1.7;
	padding-bottom: 1rem;
	color: $black;
}

.page-notice-head,
.page-notice-head2,
.page-goods-notice-head {
	margin-top: 1rem;
	font-weight: 600;
	margin-bottom: 1rem;
	border-top: 2px dotted var(--pr-darkyellow);
	padding-top: 1rem;
}

.page-notice-head2,
.page-goods-notice-head {
	border-top: none;
	padding-top: 0;
}

.page-goods-notice-head {
	margin-bottom: 0.5rem;
}

.page-goods-notice-head.bt,
.footer-copyright.bt {
	border-top: 2px dotted var(--pr-darkyellow);
	padding-top: 1rem;
}

.footer-copyright.bt {
	margin-top: 1rem;
}

.page-notice-head-sq,
.page-goods-notice-head-sq {
	color: var(--pr-darkyellow-link);
}

.page-notice-prids-color-image {
	width: 50%;
	height: auto;
	margin-top: 0.5rem;
}

.page-notice-logo {
	width: 32%;
	margin: 0 auto;
}

.page-notice-logo-image {
	width: 100%;
	height: auto;
}

.page-notice-close-button,
.page-goods-close-button {
	border-top: 2px dotted var(--pr-darkyellow);
	padding-top: 2rem;
	margin: 0 auto;
	padding-bottom: 2rem;
	text-align: center;
}

.page-goods-close-button {
	border-top: none;
}

.page-notice-close-button-text,
.page-goods-close-button-text {
	border-radius: 1rem;
	border: 1px solid var(--pr-darkyellow-link);
	padding: 0.12rem 1.5rem 0.22rem;
	transition-duration: 0.33s;
	font-size: var(--rem-vw);
}

.page-goods-close-button-text {
	color: var(--pr-darkyellow-link);
	background-color: transparent;
}

.page-notice-close-button-text:hover,
.page-goods-close-button-text:hover {
	background-color: var(--pr-darkyellow-link);
}

.page-goods-close-button-text:hover {
	color: var(--pr-darkbrown);
}

.page-goods-visual-image {
	width: 29.1%;
	margin: 0 auto;
	padding-top: 1rem;
	padding-bottom: 1.5rem;
	filter: drop-shadow(0 0 1px var(--pr-gold));
}

.page-goods-white-outer {
	padding-top: 6px;
	background-color: #ffffff88;
	width: 100vw;
	margin-left: calc(50% - 50vw);
}

.page-goods-white-box {
	position: relative;
	padding-left: calc(4 * var(--rem-vw));
	padding-right: calc(4 * var(--rem-vw));
}

.page-goods-pamph-image-box {
	position: absolute;
	right: calc(4 * var(--rem-vw));
	width: 21%;
}

.page-goods-pamph-image {
	width: 100%;
	height: auto;
	aspect-ratio: 75 / 106;
}

.page-goods-head2 {
	font-size: calc(1.2 * var(--rem-vw));
	color: var(--pr-gold);
	font-weight: 600;
	text-align: center;
}

.page-goods-head2.mb {
	margin-bottom: 0.75rem;
}

.page-goods-text,
.page-goods-notice {
	font-size: var(--rem-vw);
}

.page-goods-add {
	font-weight: 600;
	font-size: calc(0.8 * var(--rem-vw));
}

.page-goods-add li {
	font-size: calc(0.8 * var(--rem-vw));
	margin-bottom: 0;
}

.page-goods-notice {
	margin-bottom: 1rem;
}

.mt-m2 {
	margin-top: -0.5rem;
}

.page-goods-notice2 {
	font-weight: 600;
	margin-top: 3rem;
	margin-bottom: 2rem;
}

.page-goods-pamphlet-list-box {
	border: 1px solid var(--pr-gold);
	position: relative;
}

.page-goods-pamphlet-list-button::after {
	content: "";
	position: absolute;
	width: calc(8 / 16 * var(--rem-vw));
	height: calc(9 / 16 * var(--rem-vw));
	position: absolute;
	border-bottom: 9px solid var(--pr-gold);
	border-right: 8px solid transparent;
	border-left: 8px solid transparent;
	right: var(--rem-vw);
	top: calc(18 / 16 * var(--rem-vw));
	content: "";
	transition-duration: 0.33s;
	transition-property: transform, border-color;
	transform-origin: center 5px;

	transform: rotate(180deg);
	z-index: 0;
	pointer-events: none;
}

.page-goods-pamphlet-list-button:hover::after {
	border-bottom-color: var(--pr-white);
}

.page-goods-pamphlet-list-button.closed::after {}

.page-goods-pamphlet-list-button {
	padding: calc(0.4 * var(--rem-vw));
	text-align: center;
	color: var(--pr-gold);
	font-weight: 600;
	font-size: calc(1.2 * var(--rem-vw));
	transition-duration: 0.33s;
}

.page-goods-pamphlet-list-button-outer {
	transition-duration: 0.33s;
}

.page-goods-pamphlet-list-button-outer:hover {
	background-color: var(--pr-gold);
}

.page-goods-pamphlet-list-button:hover {
	cursor: pointer;
	color: var(--pr-white);
}

.page-goods-pamphlet-list {
	padding: calc(0.5 * var(--rem-vw)) calc(1 * var(--rem-vw));
	line-height: 1.7;
}

.page-goods-pamphlet-list,
.page-goods-desc-text,
.page-goods-bromide-text,
.page-goods-guide-text,
.page-goods-footer,
.page-goods-notice2 {
	font-size: calc(0.9 * var(--rem-vw));
}

.page-goods-pamphlet-list {
	color: $black;
	text-align: center;
	display: none;
}

.page-goods-pamphlet-text a {
	word-break: keep-all;
	white-space: nowrap;
}

.page-goods-acrylic,
.page-goods-2022-box {
	width: 90%;
	margin: 0 auto;
}

.page-goods-bromide,
.page-goods-acrylic {
	margin-bottom: 2rem;
}

.page-goods-all {
	margin-top: 2rem;
	border-top: 2px dotted var(--pr-darkyellow);
	padding-top: 2rem;
	position: relative;
}

.page-goods-all-notice {
	font-size: calc(0.9 * var(--rem-vw));
	padding-left: calc(4.5 * var(--rem-vw));
	font-weight: 600;
	line-height: 1.7;
	padding-bottom: 3rem;
}

.page-goods-bromide-list,
.page-goods-acrylic-list {
	display: flex;
	flex-wrap: wrap;
	margin-top: 1rem;
	margin-right: calc(-2 * var(--rem-vw));
	justify-content: center;
}

.page-goods-badge-item,
.page-goods-sheet-item {
	margin-top: 1rem;
}

.page-goods-bromide-item,
.page-goods-acrylic-item {
	width: calc(100% / 3 - 2 * var(--rem-vw));
	margin-right: calc(2 * var(--rem-vw));
	display: flex;
	flex-direction: column;
	padding-bottom: 2rem;
}

.page-goods-acrylic-item {
	width: calc(80% / 3 - 2 * var(--rem-vw));
}

.page-goods-bromide-image,
.page-goods-acrylic-image,
.page-goods-badge-image {
	width: 100%;
	height: auto;
	aspect-ratio: 24 / 11;
	display: block;
}

.page-goods-acrylic-image {
	aspect-ratio: 2 / 3;
}

.page-goods-badge-image {
	aspect-ratio: 300 / 233;
}

.page-goods-sheet-image {
	aspect-ratio: 600 / 617;
}

.page-goods-gen-image {
	aspect-ratio: 1 / 1;
}

.page-goods-desc-text,
.page-goods-bromide-text {
	margin-top: 0.25rem;
}

.page-goods-desc-text {
	text-align: center;
}

.page-goods-desc-text.goods-2022 {
	margin-top: 0;
	margin-bottom: 1rem;
}

.page-goods-box {
	display: flex;
	width: 90%;
	flex-wrap: wrap;
	margin: 0 auto;
}

.page-goods-two-row {
	width: calc(50% - 4 * var(--rem-vw));
	margin-right: calc(4 * var(--rem-vw));
}

.page-goods-two-row:nth-child(2n) {
	margin-right: 0;
	margin-left: calc(4 * var(--rem-vw));
}

.page-goods-badge-image,
.page-goods-sheet-image,
.page-goods-gen-image {
	width: 100%;
}

.page-goods-data-box {
	min-height: 88px;
}

.page-goods-gen-item {
	margin-bottom: 4rem;
}

.page-goods-assembled-image {
	border-radius: 1rem;
	border: 1px solid var(--pr-darkyellow);
}

.page-goods-assembled-text {
	color: var(--pr-gold);
}

.page-goods-guide {
	margin-bottom: 3rem;
}

.page-goods-guide,
.page-goods-footer-inner {
	padding-left: calc(4 * var(--rem-vw));
	padding-right: calc(4 * var(--rem-vw));
}

.page-goods-guide-text {
	line-height: 1.7;
}

.ml-m2 {
	margin-left: calc(-0.5 * var(--rem-vw));
}

.page-goods-guide-text li {
	font-size: calc(0.8 * var(--rem-vw));
}

.page-goods-footer {
	width: 100vw;
	margin-left: calc(50% - 50vw);
	background-color: var(--pr-darkbrown);
	color: var(--pr-white);
	padding: 2rem calc(50vw - 50%) 1rem;
	line-height: 1.7;
}

.page-goods-main {
	color: $black;
}

.goods {
	&-text {
		color: $black;
		margin-top: 2rem;
		margin-bottom: 3rem;

		.goods-link {
			transition: 0.33s;

			&:hover {
				color: white;
				cursor: pointer;
			}
		}
	}
}

.underline {
	text-decoration: underline;
}

.align-left,
.align-sm-left {
	text-align: left;
}

@media screen and(min-width: 1024px) {
	.main-data-title-text {
		font-size: 1.5rem;
		margin-bottom: 1rem;
	}

	.schedule-date-box .dates-text {
		font-size: 2.4rem;
	}

	.main-data-title-text .josefin {
		font-size: 1.2em;
	}

	.unit-name-text {
		font-size: 1.2rem;
	}

	.cast-list-item {
		font-size: 1.1rem;
		display: flex;
	}

	.cast-list-box.hotblood .cast-list-item {
		font-size: 1rem;
	}

	.schedule-title-text,
	.streaming-title-text,
	.goods-title-text,
	.page-goods-title-text {
		font-size: 2.6rem;
	}

	.schedule-date,
	.schedule-time {
		font-size: 1.3rem;
	}

	.schedule-date-box .place-text {
		font-size: 1.5rem;
		margin-bottom: 1rem;
	}

	.schedule-date-box .dates-text {
		font-size: 2.4rem;
	}

	.ticket-price-text {
		font-size: 1.2rem;
	}

	.ticket-price-title {
		font-size: 1.1rem;
	}

	.ticket-head,
	.page-goods-head {
		font-size: 1.1rem;
	}

	.ticket-head.webflyer {
		font-size: 1rem;
	}

	.ticket-notice-pre {
		font-size: 0.8rem;
	}

	.ticket-item,
	.streaming-item {
		font-size: 1rem;
	}

	.ticket-head2,
	.streaming-head2 {
		font-size: 1rem;
	}

	.ticket-data-date,
	.streaming-data-date {
		font-size: 1rem;
	}

	.ticket-data-desc,
	.streaming-data-desc {
		font-size: 0.85rem;
	}

	.ticket-resale-head {
		font-size: 1rem;
	}

	.ticket-resale-text {
		font-size: 1rem;
	}

	.ticket-resale-desc,
	.ticket-resale-list {
		font-size: 0.8rem;
	}

	.ticket-notice-head {
		font-size: 1rem;
	}

	.ticket-notice-text li,
	.page-goods li {
		font-size: 0.85rem;
	}

	.ticket-info-total {
		font-size: 1rem;
	}

	.twitter-banner-text {
		font-size: 1.6rem;
	}

	.twitter-icon,
	.instagram-icon {
		width: 2rem;
		height: 2rem;
	}

	.bg3,
	.bg2 {
		background-position: right calc(50vw - 512px + var(--pr-bg-margin)) top;
	}

	.bg-white {
		--bg-l: calc(50vw - 512px);
		--bg-r: calc(50vw + 512px);
		background: linear-gradient(to right,
				var(--pr-yellow-bg) 0%,
				var(--pr-yellow-bg) var(--bg-l),
				black var(--bg-l),
				black var(--bg-r),
				var(--pr-yellow-bg) var(--bg-r),
				var(--pr-yellow-bg) 100vw);
		position: relative;
		z-index: 1;
	}

	.event-head {
		font-size: 1.8rem;
	}

	.event-head1 {
		font-size: 1rem;
	}

	.event-head2 {
		font-size: 1.1rem;
	}

	.event-head3 {
		font-size: 1rem;
	}

	.event-text {
		font-size: 0.8rem;
	}

	.event-schedule-list,
	.event-notice-list,
	.event-schedule-notice,
	.ticket-price-notice {
		font-size: 0.8rem;
	}

	.event-schedule-head {
		font-size: 1.1rem;
	}

	.page-notice-close-button-text,
	.page-goods-close-button-text {
		font-size: 1rem;
	}

	.page-goods-white-box {
		padding-left: 4rem;
		padding-right: 4rem;
	}

	.page-goods-pamph-image-box {
		right: 4rem;
	}

	.page-goods-head2 {
		font-size: 1.2rem;
	}

	.page-goods-text,
	.page-goods-notice {
		font-size: 1rem;
	}

	.page-goods-add {
		font-size: 0.8rem;
	}

	.page-goods-add li {
		font-size: 0.8rem;
		margin-bottom: 0;
		line-height: 1.3;
	}

	.page-goods-pamphlet-list-button {
		padding: 0.4rem;
		font-size: 1.2rem;
	}

	.page-goods-pamphlet-list {
		padding: 0.5rem 1rem;
	}

	.page-goods-pamphlet-list,
	.page-goods-desc-text,
	.page-goods-all-notice,
	.page-goods-bromide-text,
	.page-goods-guide-text,
	.page-goods-footer,
	.page-goods-notice2 {
		font-size: 0.9rem;
	}

	.page-goods-all-notice {
		padding-left: 4.5rem;
	}

	.page-goods-bromide-list,
	.page-goods-acrylic-list {
		margin-right: -2rem;
	}

	.page-goods-bromide-item,
	.page-goods-acrylic-item {
		width: calc(100% / 3 - 2rem);
		margin-right: 2rem;
	}

	.page-goods-acrylic-item {
		width: calc(80% / 3 - 2rem);
	}

	.page-goods-two-row {
		width: calc(50% - 4rem);
		margin-right: 4rem;
	}

	.page-goods-two-row:nth-child(2n) {
		margin-left: 4rem;
	}

	.page-goods-guide,
	.page-goods-footer-inner {
		padding-left: 4rem;
		padding-right: 4rem;
	}

	.ml-m2 {
		margin-left: -0.5rem;
	}

	.page-goods-guide-text li {
		font-size: 0.8rem;
	}

	.page-goods-pamphlet-list-button::after {
		width: 8px;
		height: 9px;
		position: absolute;
		border-bottom: 9px solid var(--pr-gold);
		border-right: 8px solid transparent;
		border-left: 8px solid transparent;
		right: 1rem;
		top: 18px;
	}
}

.banner {
	padding-top: 3rem;
	padding-bottom: 3rem;
	position: relative;
	line-height: 1.7;

	@media screen and (max-width: 768px) {
		padding-bottom: 2rem;
	}

	.head {
		font-size: 1.2rem;
		line-height: 1.4;

		&.maisy {
			color: $orange;
		}

		&.refly {
			color: $blue;
		}

		&.emekare {
			color: $green;
		}
	}
}

.event-link-box {
	background: url(../../public/img/mre_menu.png) repeat-y;
	background-size: calc(100% - 6rem) auto;
	background-position: center top, center top;
	padding: 0.8rem 3rem;
	text-align: center;
	font-weight: 600;
	color: white;
	margin-top: 1rem;
	height: 100px;

	position: relative;
	transition: opacity 0.5s;
	opacity: 0.8;

	@media screen and (max-width: 768px) {
		height: 80px;
		background: url(../../public/img/mre_menu.png) repeat-y;
		background-size: calc(100% - 2rem) auto;
		background-position: center top, center top;
		padding-left: 1rem;
		padding-right: 1rem;
	}

	&:hover {
		cursor: pointer;
		opacity: 1;
	}

	&::before,
	&::after {
		position: absolute;
		content: "";
		background: url(../../public/img/title_mre.png) no-repeat;
		width: 44px;
		height: 100px;
		bottom: 0;
		left: 3 * $rem;
		opacity: 0.8;

		@media screen and (min-width: 1024px) {
			left: 3rem;
		}

		@media screen and (max-width: 768px) {
			left: 0;
			background-size: 35.2px 80px;
			height: 80px;
		}
	}

	&::after {
		transform: scaleX(-1);
		right: 3 * $rem;
		left: unset;

		@media screen and (max-width: 768px) {
			right: 0;
		}

		@media screen and (min-width: 1024px) {
			right: 3rem;
		}
	}

	.copy {
		font-size: 1.1rem;

		@media screen and (max-width: 768px) {
			font-size: 0.8rem;
			margin-bottom: 0;
		}
	}

	.text {
		text-transform: uppercase;
		font-size: 2.6rem;
		margin-top: -0.25rem;
		margin-bottom: -1.4rem;

		@media screen and (max-width: 768px) {
			font-size: 1.7rem;
			margin-bottom: -0.7rem;
			margin-top: 0rem;
		}
	}
}

@media screen and (max-width: 768px) {

	.brsp,
	.sp {
		display: block;
	}

	.brnosp,
	.nosp,
	.brnosp-inline {
		display: none;
	}

	.sp-inline,
	.sp-show {
		display: inline;
	}

	.url-text {
		word-break: break-all;
	}

	.bar-bd {
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		// background-color: $white-op5;
		display: none;
		z-index: 3;
	}

	.bar-outer {
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		height: auto;
		background-color: $black-op8;
		background-repeat: no-repeat;
		background-size: auto;
		margin: 0;
		padding-bottom: 0.25rem;
		width: 100%;
		display: none;
		z-index: 4;

		.story-title,
		.goods-title {
			margin-top: 2rem;

			&.maisy {
				color: $liteorange;
			}

			&.refly {
				color: $liteblue;
			}

			&.emekare {
				color: $litegreen;
			}
		}
	}

	.bar {
		flex-direction: column;
		height: auto;
		margin-top: 1rem;
		font-size: 1.4rem;
		align-items: flex-start;
		text-align: left;
		justify-content: flex-start;
		padding-top: 0;
	}

	.bar .guide {
		background-color: var(--pr-skyblue);
	}

	.bar::before {
		background: none;
	}

	.bar a {
		width: 100%;
		padding: 0.7rem 0.5rem 0.5rem 0.8rem;
		text-align: left;
		justify-content: flex-start;
		position: relative;
		border-top: 1px solid var(--pr-white);
		margin-left: 0;
		line-height: 1.1;
	}

	.bar a::after {
		border-right: none;
	}

	.bar a:first-child {
		display: none;
	}

	.bar a:nth-child(2)::after {
		border-top: none;
	}

	.bar a:last-child {
		border-bottom: 1px solid var(--pr-white);
	}

	.bar-close {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 48px;
		z-index: 5;
		background: linear-gradient(to left,
				var(--pr-gradient-liteblue),
				var(--pr-gradient-skyblue));
		transition-duration: 0.2s;
	}

	.bar-close.open,
	.bar-close.top-bar {
		background: unset;
	}

	.bar-home-link {
		/* background: url(../../public/img/home.svg); */
		--zoom: 0.45;
		--width: calc(131px * var(--zoom));
		--height: calc(133px * var(--zoom));
		background-size: var(--width) var(--height);
		background-repeat: no-repeat;
		position: absolute;
		width: var(--width);
		height: var(--height);
		top: 12px;
		right: 12px;
		z-index: 6;
		transition-duration: 0.33s;
	}

	.open .bar-home-link {
		opacity: 0;
	}

	label#menu {
		// color: white;
		font-size: 1.8rem;
		cursor: pointer;
		display: block;
		margin: 0 auto 0.5rem 0.6rem;
		text-align: left;
		z-index: 4;
	}

	label#menu:before {
		content: "\2630";
		font-size: 1.9rem;
	}

	input#nav:checked~label#menu {
		transform: translate(4px, -2px);
	}

	input#nav:checked~label#menu:before {
		content: "×";
		/* × */
		font-size: 2rem;
	}

	input#nav:checked~label#menu:hover:before {
		color: var(--pr-darkblue);
		// background-color: var(--pr-white);
	}

	.notice-link-box {
		font-size: 0.8rem;
	}

	.notice-link-text::after,
	.notice-link-text::before {
		top: calc(-2.1rem * 0.8);
		width: calc(64px * 0.8);
		height: calc(64px * 0.8);
		background-size: calc(64px * 0.8);
	}

	.notice-link-text::before {
		right: -4rem;
	}

	.notice-link-text::after {
		left: -4rem;
	}

	.notice-text {
		padding-left: 0.5rem;
		padding-right: 0.5rem;
	}

	.notice-text-text {
		font-size: 0.8rem;
	}

	.notice-window {
		left: 1rem;
		right: 1rem;
		height: 600px;
		width: unset;
	}

	.notice-inner {
		padding: 2rem 1rem;
	}

	.notice-window-close-button {
		right: 1rem;
	}

	.bg {
		background-size: 200% auto;
		background-position: 50% 0;
	}

	.news-info-box {
		padding: 0 1rem;
	}

	.prids-logo-image {
		width: 46%;
	}

	.main-data-box {
		padding-top: 1rem;
		padding-bottom: 1rem;
	}

	.main-data-title-text {
		font-size: 1.2rem;
		margin-bottom: 1rem;
	}

	.main-data-dates-text {
		font-size: 2.6rem;
	}

	.main-data-dates-text .day {
		font-size: 0.5em;
	}

	.main-data-dates-text .to {
		font-size: 0.5em;
	}

	.main-data-title-text .josefin {
		font-size: 1.2em;
	}

	.main-data-place-text {
		font-size: 1.1rem;
		margin-bottom: 0.8rem;
	}



	.ticket-head.webflyer {
		font-size: 0.8rem;
		width: 120px;
	}

	.info-title,
	.cast-title,
	.staff-title,
	.goods-title {
		font-size: 1.6rem;
		padding-top: 3rem;
	}



	.info-title {
		margin-left: 0;
	}

	.goods-title {
		padding-top: 4rem;
	}

	.news-head {
		flex-direction: column;
		align-items: flex-start;
	}

	.news-text {
		padding: 0.75rem 0.35rem 0.15rem;
		line-height: 1.5;
	}

	.cast-title {
		margin-right: 1rem;
		margin-bottom: 1rem;
		padding-top: 1rem;
	}

	.cast-list {
		padding: 0 1rem;
	}

	.unit-name-text {
		font-size: 1.2rem;
		margin-right: 1rem;
	}

	.unit-name-text.refly {
		background: linear-gradient(to right, transparent 50%, $blue);
	}

	.unit-name-text.emekare {
		background: linear-gradient(to right,
				transparent 50%, $green);
	}

	.cast-list-box {
		flex-wrap: wrap;
		padding-top: 0;
		margin-top: 1rem;
		margin-left: calc(-0.5rem);
		margin-right: 0.5rem;
		padding-right: 0;
		padding-bottom: 0;
	}



	.cast-list.hotblood {
		margin-top: -1rem;
	}

	.cast-image-box {
		padding-left: 0.5rem;
		padding-right: 0.5rem;
	}

	.staff-divider {
		margin-left: 1rem;
		margin-right: 1rem;
		width: calc(100% - 2rem);
		margin-top: -1rem;
	}

	.story-divider {
		margin-bottom: 1.5rem;
		margin-top: 1.5rem;
		margin-left: 0;
		width: 100%;
	}

	.staff-box::before,
	.story-box::before::before {
		top: 0;
	}

	.staff-box,
	.story-box {
		margin-top: -2rem;
	}

	.staff-title,
	.goods-title {
		margin-left: 1rem;
		margin-top: 1rem;
	}

	.cast-bg {
		margin-top: -1rem;
	}

	.staff-text,
	.story-text {
		font-size: 0.85rem;
		line-height: 1.7;
		margin-top: 1rem;
		padding-bottom: 2rem;
		padding-left: 1.25rem;
		padding-right: 1.25rem;
	}

	.schedule-box {
		padding-top: 1rem;
		padding-bottom: 2rem;
	}

	.schedule-table-box {
		width: calc(100% - 2rem);
	}

	.schedule-title-text,
	.goods-title-text,
	.page-goods-title-text {
		font-size: 1.6rem;
	}

	.page-goods-title {
		padding-bottom: 1rem;
	}

	.info-title {
		padding-top: 1rem;
	}

	.schedule-date-box .dates-text {
		font-size: 2rem;
	}

	.place-text {
		font-size: 1rem;
		margin-bottom: 1rem;
	}

	.schedule-table .holiday {
		padding-right: 0rem;
	}

	.schedule-date {
		padding-right: 1.1rem;
	}

	.schedule-date,
	.schedule-time {
		font-size: 0.85rem;
	}

	.schedule-time {
		white-space: nowrap;
	}

	.schedule-date-box .dates-text {
		margin-top: 4rem;
	}

	.ticket-price-text {
		font-size: 1rem;
		margin-top: 4rem;
		margin-bottom: 1rem;
	}

	.ticket-price-title {
		font-size: 1rem;
	}

	.ticket-box,
	.streaming-box {
		padding-top: 1rem;
	}

	.streaming-box {
		padding-bottom: 3rem;
	}

	.ticket-head {
		font-size: 1rem;
		margin-left: 0.5rem;
		margin-right: 0.5rem;
	}

	.page-goods-head {
		font-size: 1rem;
		margin-left: 0;
		margin-right: 0;
		margin-bottom: 1rem;
	}

	.page-goods-head.guide {
		margin-top: 2rem;
	}

	.ticket-head.playguide {
		margin-top: 2rem;
	}

	.bg3,
	.bg2 {
		--pr-bg-margin: 180px;
		--pr-bg-width: 240px;
		background-position: right calc(50vw - 512px + var(--pr-bg-margin)) top;
	}

	.ticket-box-inner,
	.streaming-box-inner {
		padding-left: 1rem;
		padding-right: 1rem;
	}

	.ticket-boke-box,
	.streaming-boke-box {
		filter: drop-shadow(0 0 3px var(--pr-black-bg));
		padding-left: 1rem;
		padding-right: 1rem;
	}

	.streaming-boke-box {
		padding-right: 0.5rem;
	}

	.ticket-notice-pre {
		font-size: 0.8rem;
		line-height: 1.7;
	}

	.ticket-item,
	.streaming-item,
	.ticket-head2,
	.streaming-head2 {
		font-size: 0.85rem;
	}

	.ticket-data-url,
	.streaming-data-url {
		font-size: 0.95rem;
	}

	.ticket-data-date,
	.streaming-data-date {
		font-size: 0.8rem;
	}

	.ticket-data-desc,
	.streaming-data-desc {
		font-size: 0.65rem;
	}

	.ticket-notices-box {
		margin-left: 1rem;
		margin-right: 1rem;
		width: calc(100% - 2rem);
	}

	.ticket-notice-box {
		margin-top: 1rem;
	}

	.ticket-resale {
		margin-top: 3rem;
	}

	.ticket-resale-head,
	.ticket-notice-head {
		font-size: 0.9rem;
	}

	.ticket-resale-text,
	.ticket-notice-text {
		padding-left: 1rem;
		padding-right: 1rem;
		font-size: 0.85rem;
	}

	.ticket-resale-desc,
	.ticket-resale-list,
	.ticket-notice-text li,
	.page-goods li {
		font-size: 0.8rem;
	}

	.page-goods li {
		margin-bottom: 0.5rem;
		line-height: 1.6;
	}

	.ticket-info-total {
		font-size: 0.8rem;
	}

	.ticket-notice-head::after,
	.ticket-resale-head::after {
		width: 6px;
		height: 6px;
		border-bottom: 6px solid var(--pr-darkyellow);
		border-right: 5px solid transparent;
		border-left: 5px solid transparent;
		right: 10px;
		top: 16px;
	}

	.ticket-notice-head.closed::after,
	.ticket-resale-head.closed::after {
		top: 11px;
	}

	.cast-bg::before {
		width: 100%;
	}

	.main-data-dates-text .day {
		margin-left: -0.6rem;
	}

	.event-border {
		padding: 1rem 0.8rem 1rem 1rem;
		padding-bottom: 1rem;
	}

	.event-border::after {
		background-size: 84px;
		width: 84px;
		height: 84px;
		top: -8px;
		right: -8px;
	}

	.event-box {
		margin-bottom: 3rem;
	}

	.event-box-inner {
		padding-left: 1rem;
		padding-right: 1rem;
	}

	.event-head {
		font-size: 1.4rem;
		margin-bottom: 0.5rem;
	}

	.event-head1 {
		font-size: 0.8rem;
	}

	.event-head2 {
		font-size: 1rem;
	}

	.event-head3 {
		font-size: 0.9rem;
	}

	.event-text {
		font-size: 0.8rem;
	}

	.event-tokuten-coaster-box {
		margin: 0.5rem 0 0.5rem 0;
		width: 100%;
	}

	.event-tokuten-coaster-image {
		width: 100%;
	}

	.event-tokuten-coaster-image.image2 {
		width: 66.66%;
		margin-top: 0.5rem;
	}

	.event-schedule-list {
		font-size: 0.8rem;
	}

	.event-notice-list {
		font-size: 0.8rem;
	}

	.event-schedule-head {
		font-size: 1rem;
		padding: 0.75rem 1rem;
	}

	.event-schedule-notice {
		font-size: 0.7rem;
		margin-top: 0.5rem;
	}

	.ticket-price-notice {
		font-size: 0.8rem;
		margin-top: 0.5rem;
		padding-left: 2rem;
		padding-right: 2rem;
		text-align: left;
		filter: drop-shadow(0 0 1px black);
	}

	.event-schedule-notice li,
	.ticket-price-notice li {
		text-indent: -0.7rem;
	}

	.event-schedule-head::before,
	.event-schedule-head::after {
		width: 58.5px;
		height: 58.5px;
		background-size: 58.5px;
		top: 7.5px;
		right: -6px;
	}

	.event-schedule-head::after {
		left: -6px;
	}

	.event-schedule-head-inner {
		height: calc(100% - 10px);
		top: 5px;
		bottom: 5px;
		filter: drop-shadow(0 0 1px black);
	}

	.event-schedule-head-inner::after {
		width: 10px;
		height: 10px;
		border-bottom: 8px solid var(--pr-darkyellow);
		border-right: 8px solid transparent;
		border-left: 8px solid transparent;
		right: 60px;
		top: 22px;
	}

	.event-schedule-head-inner.closed::after {
		top: 26px;
	}

	.page-notice-box {
		padding-left: 1.25rem;
		padding-right: 1rem;
	}

	.page-notice-logo {
		width: calc(200% / 3 * 0.8);
	}

	.page-notice-title {
		padding-top: 0;
	}

	.mb-m4 {
		margin-bottom: -1rem;
	}

	.page-goods-visual-image {
		width: calc(200% / 3 * 0.8);
	}

	.page-notice-prids-color-image {
		width: 75%;
	}

	.page-goods-white-box {
		padding-left: 1rem;
		padding-right: 1rem;
	}

	.page-goods-pamph-image-box {
		position: relative;
		right: unset;
		order: 2;
		width: calc(200% / 3);
		margin: 0 auto 1rem;
	}

	.page-goods-head2 {
		font-size: 1rem;
	}

	.page-goods-gen-item {
		margin-bottom: 2rem;
		margin-top: 0.2rem;
	}

	.page-goods-box.gen .page-goods-data-box {
		min-height: unset;
	}

	.page-goods-box.gen .page-goods-head2 {
		font-size: 0.9rem;
		/* min-height: 66px; */
	}

	.page-goods-box.gen .page-goods-desc-text {
		/* min-height: 42.5px; */
		font-size: 0.8rem;
	}

	.page-goods-head2.padded {
		margin-bottom: 1.53rem;
	}

	.page-goods-desc-text.padded {
		margin-bottom: 1.2rem;
	}

	.page-goods-pamph-box {
		display: flex;
		flex-direction: column;
	}

	.order-3 {
		order: 3;
	}

	.page-goods-pamphlet-list-button {
		width: 100%;
		font-size: 1rem;
		padding: 0.4rem 0;
		margin-left: -0.75rem;
	}

	.page-goods-pamphlet-list {
		padding: 0.6rem;
	}

	.page-goods-all-notice {
		padding-left: 1rem;
		font-size: 0.9rem;
	}

	.page-goods-all-notice::after {
		width: 60px;
		height: 60px;
		top: 1.8rem;
		left: -0.75rem;
	}

	.page-goods-box,
	.page-goods-acrylic,
	.page-goods-2022-box {
		width: 100%;
		padding-left: 0;
		padding-right: 0;
	}

	.page-goods-bromide {
		padding-left: 0;
		padding-right: 0;
	}

	.page-goods-bromide,
	.page-goods-acrylic {
		overflow: hidden;
	}

	.page-goods-bromide-list,
	.page-goods-acrylic-list {
		margin-right: -1rem;
	}

	.page-goods-bromide-item {
		width: calc(100% / 2 - 1rem);
		margin-right: 1rem;
		display: flex;
		flex-direction: column;
		padding-bottom: 0.5rem;
	}

	.page-goods-acrylic-item {
		width: calc(100% / 3 - 1rem);
		margin-right: 1rem;
		padding-bottom: 0.5rem;
	}

	.page-goods-two-row {
		width: calc(50% - 0.5rem);
		margin-right: 0.5rem;
	}

	.page-goods-two-row:nth-child(2n) {
		width: calc(50% - 0.5rem);
		margin-right: 0;
		margin-left: 0.5rem;
	}

	.page-goods-guide,
	.page-goods-footer-inner {
		padding-left: 1rem;
		padding-right: 1rem;
	}

	.bromide-empty {
		display: none;
	}

	.page-goods-desc-text,
	.page-goods-pamphlet-list,
	.page-goods-guide-text,
	.page-goods-footer,
	.page-goods-notice2 {
		font-size: 0.9rem;
	}

	.page-goods-add {
		font-size: 0.8rem;
	}

	.page-goods-add li {
		font-size: 0.8rem;
		margin-bottom: 0;
		line-height: 1.3;
	}

	.page-goods-notice2 {
		margin-top: 1rem;
		margin-bottom: 1rem;
	}

	.page-notice-close-button-text,
	.page-goods-close-button-text {
		font-size: 1rem;
	}

	.page-goods-pamphlet-list-button::after {
		width: 10px;
		height: 10px;
		border-bottom: 8px solid var(--pr-gold);
		border-right: 8px solid transparent;
		border-left: 8px solid transparent;
		top: 12.5px;
		transform-origin: 8px 6.5px;
		right: 9px;
	}

	.align-sm-left {
		text-align: center;
	}

	.goods-link-button-outer {
		margin-left: 0;
	}

	.goods-link-button {
		padding: 0.3rem 0 0.3rem;
		font-size: 0.8rem;
	}

	.goods-link-text-jp {
		font-size: 0.8rem;
	}
}</style>